webpackJsonp([2],{

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocalizedLabels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);


function getLocalizedLabels(labelObj, defaultText) {
  labelObj = labelObj || [];
  var ret = [];

  labelObj.forEach(function (l) {
    if (l.language) ret.push({ language: l.language, label: l.label || defaultText });
  });

  __WEBPACK_IMPORTED_MODULE_0_config__["languages"].forEach(function (lang) {
    if (!ret.find(function (l) {
      return l.language === lang.id;
    })) {
      ret.push({ language: lang.id, label: defaultText });
    }
  });
  return ret;
}

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item__ = __webpack_require__(218);







var Context = function (_Item) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Context, _Item);

  function Context(contextConfig, layers) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Context);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Context.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Context)).call(this, contextConfig));

    _this.originalId = contextConfig.id;
    _this.active = !!contextConfig.active;

    var findLayerById = function findLayerById(arr, id) {
      return arr.find(function (item) {
        return item.originalId === id;
      });
    };
    var tLayers = contextConfig.layers && contextConfig.layers.map(function (id) {
      return findLayerById(layers, id);
    }).filter(function (layer) {
      return !!layer;
    });
    _this.layers = tLayers || [];
    _this.inlineLegendUrl = contextConfig.inlineLegendUrl || null;
    _this.opacity = contextConfig.opacity || 1;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Context, [{
    key: 'legend',
    value: function legend(locale) {
      return this.layers.map(function (layer) {
        var legendUrl = null;
        if (layer.legend) {
          if (layer.legend.type === 'wms') {
            var wmsLegendStyle = layer.legend.style.replace('$(_lang)', locale);
            legendUrl = layer.serverUrls[0] + '?LEGEND_OPTIONS=fontColor:ffffff;fontAntiAliasing:true\n&LAYER=' + layer.name + '&STYLE=' + wmsLegendStyle + '&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=18&HEIGHT=18&TRANSPARENT=true';
          } else {
            legendUrl = layer.legend.url;
          }
        } else if (layer.styles) {
          var style = layer.styles.find(function (l) {
            return l.language === locale;
          });
          var _wmsLegendStyle = style ? style.label : null;
          legendUrl = layer.serverUrls[0] + '?LEGEND_OPTIONS=fontColor:ffffff;fontAntiAliasing:true\n&LAYER=' + layer.name + '&STYLE=' + _wmsLegendStyle + '&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=18&HEIGHT=18&TRANSPARENT=true';
        }
        return legendUrl;
      }).filter(function (url) {
        return url;
      });
    }
  }, {
    key: 'hasLegends',
    get: function get() {
      return this.layers.some(function (layer) {
        return layer.legend || layer.styles && layer.styles.some(function (s) {
          return s.label;
        });
      });
    }
  }]);

  return Context;
}(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Context);

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b0b80fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getLayers;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveConfiguration;
/* harmony export (immutable) */ __webpack_exports__["a"] = getConfigurationHistory;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreVersion;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPrintRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__httpRequest__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layer__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__group__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_print_json__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_print_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__map__ = __webpack_require__(54);
















var _Config = function _Config(json) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, _Config);

  var layers = json.layers.map(function (layerConf) {
    return new __WEBPACK_IMPORTED_MODULE_7__layer__["a" /* default */](layerConf);
  }),
      contexts = json.contexts.map(function (contextConf) {
    return new __WEBPACK_IMPORTED_MODULE_8__context__["a" /* default */](contextConf, layers);
  });

  this.groups = new __WEBPACK_IMPORTED_MODULE_9__group__["a" /* default */](json.group, contexts, null);

  this.contexts = contexts.filter(function (c) {
    return _this.groups.findById(c.id);
  });

  this.layers = layers.filter(function (l) {
    return _this.contexts.some(function (c) {
      return c.layers.indexOf(l) !== -1;
    });
  });

  this.contexts.forEach(function (c) {
    c.layers.forEach(function (l) {
      l.opacity = c.opacity;
    });
  });
};

function getLayers() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var url = __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].baseUrl + __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].getLayersConfigUrl;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__httpRequest__["a" /* default */])('GET', url).then(function (responseText) {
      return resolve(new _Config(JSON.parse(responseText)));
    }).catch(function (error) {
      return reject(error.statusText || error.message);
    });
  });
}

function serializeConfiguration(groupConfig, layersRank) {
  var contextsConfig = groupConfig.recReduce(function (acc, current) {
    return acc.concat(current);
  }, []);
  var layersConfig = groupConfig.recReduce(function (acc, current) {
    return [].concat.apply(acc, current.layers);
  }, []);
  layersConfig = layersRank.map(function (id) {
    return layersConfig.find(function (l) {
      return l.id === id;
    });
  }).filter(function (x) {
    return x;
  });

  var layerReplacer = function layerReplacer(key, value) {
    switch (key) {
      case 'originalId':
      case 'urls':
      case 'opacity':
        return undefined;
      case 'serverUrls':
        return value || undefined;
      case 'legend':
      case 'sourceLink':
      case 'sourceLabel':
        return value || undefined;
      case 'times':
        var t = value.map(function (t) {
          return t.iso8601;
        });
        return t && t.length ? t : undefined;
      case 'styles':
        var styles = value.map(function (s) {
          return s.label ? s : null;
        }).filter(function (s) {
          return !!s;
        });

        return styles.length ? styles : undefined;
      default:
        return value;
    }
  };
  var layers = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(layersConfig, layerReplacer));

  var contextReplacer = function contextReplacer(key, value) {
    switch (key) {
      case 'layers':
        return value.length ? value.map(function (l) {
          return l.id;
        }) : undefined;
      case 'inlineLegendUrl':
      case 'infoFile':
        return value || undefined;
      case 'parent':
      case 'hasLegends':
      case 'times':
      case 'originalId':
        return undefined;
      default:
        return value;
    }
  };
  var contexts = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(contextsConfig, contextReplacer));

  var groupReplacer = function groupReplacer(key, value) {
    switch (key) {
      case '':
        return {
          exclusive: value.exclusive,
          items: value.items
        };
      case 'id':
      case 'parent':
        return undefined;
      case 'infoFile':
        return value || undefined;
      case 'items':
        if (value.length === 0) return undefined;
        return value.map(function (item) {
          return item.isGroup ? { group: item } : { context: item.id };
        });
      default:
        return value;
    }
  };
  var group = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(groupConfig, groupReplacer));

  var obj = {
    $schema: '../../layersJsonSchema_v2.json',
    layers: layers,
    contexts: contexts,
    group: group
  };

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj);
}

function saveConfiguration(conf, layersRank) {
  var url = __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].baseUrl + __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].saveLayersConfigUrl;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__httpRequest__["a" /* default */])('POST', url, serializeConfiguration(conf, layersRank), [['Content-Type', 'application/json'], ['Authorization', __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].getAuthToken()]]);
}

function getConfigurationHistory() {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var url = __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].baseUrl + __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].getLayersConfigHistoryUrl;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__httpRequest__["a" /* default */])('GET', url, null, [['Authorization', __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].getAuthToken()]]).then(function (responseText) {
      return resolve(JSON.parse(responseText));
    }).catch(function (error) {
      return reject(error);
    });
  });
}

function restoreVersion(version) {
  var url = __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].baseUrl + __WEBPACK_IMPORTED_MODULE_10_config__["layersConfigApi"].restoreVersionUrl + '?version=' + version;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__httpRequest__["a" /* default */])('GET', url, null, [['Authorization', __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].getAuthToken()]]);
}

function getPrintRequest(activeLayers, activeContexts, locale, annotationLayer) {
  var scales = [1128, 2256, 4513, 9027, 18055, 36111, 72223, 144447, 288895, 577790, 1155581, 2311162, 4622324, 9244649, 18489298, 36978596, 73957193, 147914387, 295828775, 591657550];
  var scale = Math.round(39.37 * 90 * __WEBPACK_IMPORTED_MODULE_12__map__["a" /* default */].getView().getResolution());
  var printScale = scales.find(function (s) {
    return s >= scale;
  }) || scales.slice(-1)[0];

  __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.pages[0].center = __WEBPACK_IMPORTED_MODULE_12__map__["a" /* default */].getView().getCenter();
  __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.pages[0].scale = printScale;

  var visibleActiveLayers = activeLayers.filter(function (layer) {
    return !!layer.visible;
  });
  if (!visibleActiveLayers.length) return;
  var reversedWmsGroups = visibleActiveLayers.reduce(function (grouped, layer) {
    switch (layer.type) {
      case 'osm':
      case 'bing-aerial':
      case 'google':
      case 'esri':
        grouped.push([layer]);
        return grouped;
      case 'wms':
        if (!grouped.length) grouped.push([]);
        var lastGroup = grouped[grouped.length - 1];
        if (!lastGroup.length || lastGroup[0].type === 'wms' && lastGroup[0].serverUrls[0] !== layer.serverUrls[0]) {
          lastGroup.unshift(layer);
          return grouped;
        } else {
          grouped.push([layer]);
          return grouped;
        }
    }
  }, []);

  reversedWmsGroups = [].concat.apply([], reversedWmsGroups);

  var baseConfig = {
    maxExtent: [-20037508.3392, -20037508.3392, 20037508.3392, 20037508.3392],
    tileSize: [256, 256],
    resolutions: [156543.0339, 78271.51695, 39135.758475, 19567.8792375, 9783.93961875, 4891.969809375, 2445.9849046875, 1222.99245234375, 611.496226171875, 305.7481130859375, 152.87405654296876, 76.43702827148438, 38.21851413574219, 19.109257067871095, 9.554628533935547, 4.777314266967774, 2.388657133483887, 1.1943285667419434, 0.5971642833709717],
    singleTile: false
  };

  var patchRelativeBaseUrl = function patchRelativeBaseUrl(url) {
    if (url && url.startsWith('/')) {
      return __WEBPACK_IMPORTED_MODULE_10_config__["map"].defaultGeoServerURLs[0];
    } else {
      return url;
    }
  };

  __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.layers = reversedWmsGroups.map(function (layer) {
    if (!layer.visible) return null;

    switch (layer.type) {
      case 'wms':
        return {
          type: 'wms',
          layers: [layer.name],
          baseURL: patchRelativeBaseUrl(layer.serverUrls[0]),
          format: layer.imageFormat
        };
      case 'osm':
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, baseConfig, {
          type: 'OSM',
          baseURL: 'http://a.tile.openstreetmap.org/',
          extension: 'png'
        });
      case 'esri':
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, baseConfig, {
          type: 'XYZ',
          baseURL: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile',
          extension: 'jpg',
          path_format: '/${z}/${y}/${x}'
        });
      default:
        return null;
    }
  }).filter(function (l) {
    return !!l;
  });

  if (annotationLayer) {
    __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.layers = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.layers), [{
      type: 'Vector',
      name: 'Annotations',
      opacity: 1,
      styleProperty: 'vector_style',
      styles: {},
      geoJson: annotationLayer
    }]);
  }

  var legends = [];
  __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.legends = activeContexts.forEach(function (context) {
    var contextLabel = context.labels.find(function (l) {
      return l.language === locale;
    }).label;
    if (context.inlineLegendUrl) {
      legends.push({
        classes: [{
          icons: [context.inlineLegendUrl],
          name: ''
        }],
        name: contextLabel
      });
    } else if (context.hasLegends) {
      var legend = {
        classes: [],
        name: contextLabel
      };
      context.layers.forEach(function (l) {
        if (!l.legend) return;

        switch (l.legend.type) {
          case 'url':
            if (!l.legend.url.startsWith('http://') && !l.legend.url.startsWith('https://')) {
              legend.classes.push({
                icons: [window.location.origin + window.location.pathname + l.legend.url],
                name: ''
              });
            } else {
              legend.classes.push({
                icons: [l.legend.url],
                name: ''
              });
            }
            break;
          case 'wms':
            var wmsLegendStyle = void 0;
            if (l.legend) {
              wmsLegendStyle = l.legend.style.replace('$(_lang)', locale);
            } else if (l.styles) {
              var style = l.styles.find(function (l) {
                return l.language === locale;
              });
              wmsLegendStyle = style ? style.label : null;
            }
            var legendUrl = patchRelativeBaseUrl(l.serverUrls[0]) + '?LEGEND_OPTIONS=fontColor:000000;fontAntiAliasing:true&LAYER=' + l.name + '&STYLE=' + wmsLegendStyle + '&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=18&HEIGHT=18&TRANSPARENT=true';

            legend.classes.push({
              icons: [legendUrl],
              name: ''
            });
            break;
          default:
            return;
        }
      });
      legends.push(legend);
    }
  });

  __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a.legends = legends.filter(function (l) {
    return !!l;
  });

  return __WEBPACK_IMPORTED_MODULE_11__assets_print_json___default.a;
}

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__httpRequest__ = __webpack_require__(77);







var i18nVuexModule = {
  state: {
    locale: null,
    fallback: null,
    translations: {}
  },
  mutations: {
    SET_LOCALE: function SET_LOCALE(state, _ref) {
      var locale = _ref.locale;

      state.locale = locale;
    },
    ADD_LOCALE: function ADD_LOCALE(state, _ref2) {
      var locale = _ref2.locale,
          translations = _ref2.translations;

      state.translations[locale] = flattenTranslations(translations);

      try {
        if (state.translations.__ob__) state.translations.__ob__.dep.notify();
      } catch (ex) {}
    },
    REMOVE_LOCALE: function REMOVE_LOCALE(state, _ref3) {
      var locale = _ref3.locale;

      if (state.translations.hasOwnProperty(locale)) {
        if (state.locale === locale) {
          state.locale = null;
        }

        var translationCopy = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.translations);

        delete translationCopy[locale];

        state.translations = translationCopy;
      }
    },
    SET_FALLBACK_LOCALE: function SET_FALLBACK_LOCALE(state, _ref4) {
      var locale = _ref4.locale;

      state.fallback = locale;
    }
  },
  actions: {
    setLocale: function setLocale(context, payload) {
      context.commit({
        type: 'SET_LOCALE',
        locale: payload.locale
      });
    },
    addLocale: function addLocale(context, _ref5) {
      var locale = _ref5.locale,
          translations = _ref5.translations;

      context.commit({
        type: 'ADD_LOCALE',
        locale: locale,
        translations: translations
      });
    },
    loadLocale: function loadLocale(_ref6, _ref7) {
      var dispatch = _ref6.dispatch;
      var locale = _ref7.locale,
          url = _ref7.url;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__httpRequest__["a" /* default */])('GET', url).then(function (responseText) {
        dispatch('addLocale', { locale: locale, translations: JSON.parse(responseText) });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }).catch(function (e) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(e);
      });
    },
    removeLocale: function removeLocale(context, _ref8) {
      var locale = _ref8.locale,
          translations = _ref8.translations;

      context.commit({
        type: 'REMOVE_LOCALE',
        locale: locale,
        translations: translations
      });
    },
    setFallbackLocale: function setFallbackLocale(context, _ref9) {
      var locale = _ref9.locale;

      context.commit({
        type: 'SET_FALLBACK_LOCALE',
        locale: locale
      });
    }
  }
};

var flattenTranslations = function flattenTranslations(translations) {
  var flattened = {};

  for (var i in translations) {
    if (!translations.hasOwnProperty(i)) continue;

    var translation = translations[i];

    if (isArray(translation)) {
      if (translation.find(function (el) {
        return typeof el !== 'string';
      })) {
        console.warn('i18n:', 'currently only arrays of strings are supported', translation);
      }

      flattened[i] = translation;
    } else if ((typeof translation === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(translation)) === 'object' && translation !== null) {
      var flatObject = flattenTranslations(translation);

      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        flattened[i + '.' + x] = flatObject[x];
      }
    } else {
      flattened[i] = translation;
    }
  }
  return flattened;
};

function isArray(obj) {
  return !!obj && Array === obj.constructor;
}

/* harmony default export */ __webpack_exports__["a"] = (i18nVuexModule);

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(157);







var Group = function (_Item) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Group, _Item);

  function Group(groupConfig, contexts, parent) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Group);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Group.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Group)).call(this, groupConfig));

    _this.parent = parent;
    _this.exclusive = !!groupConfig.exclusive;

    if (groupConfig.exclusive) {
      if (typeof groupConfig.allowDisableAll === 'undefined') _this.allowDisableAll = true;else _this.allowDisableAll = !!groupConfig.allowDisableAll;
    }

    _this.items = (groupConfig.items || []).map(function (item) {
      if (typeof item.context !== 'undefined') {
        var context = contexts.find(function (c) {
          return c.originalId === item.context;
        }) || new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */]({ id: item.context, label: item.context });
        context.parent = _this;

        return context;
      }
      return item.group && new Group(item.group, contexts, _this);
    });
    return _this;
  }

  return Group;
}(__WEBPACK_IMPORTED_MODULE_4__item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Group);

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(151);




var Item = function () {
  function Item(conf) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Item);

    this.id = Item.nextId++;
    this.infoFile = conf.infoFile || null;
    this.labels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* getLocalizedLabels */])(conf.labels);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Item, [{
    key: 'recReduce',
    value: function recReduce(fn, val) {
      return this.items.reduce(function (acc, item) {
        return item.isGroup ? item.recReduce(fn, acc) : fn(acc, item);
      }, val);
    }
  }, {
    key: 'findById',
    value: function findById(id) {
      if (this.id === id) return this;
      return this.isGroup && this.items.reduce(function (found, item) {
        return found || item.findById(id);
      }, null);
    }
  }, {
    key: 'isGroup',
    get: function get() {
      return !!this.items;
    }
  }]);

  return Item;
}();

Item.nextId = 0;
/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layersConfig__ = __webpack_require__(211);






/* harmony default export */ __webpack_exports__["a"] = ({
  enableFeedback: function enableFeedback($store) {
    $store.commit('enable_feedback', { enable: true });
  },
  enableUpload: function enableUpload($store) {
    $store.commit('show_file_drop_modal', { show: true });
  },
  showLogin: function showLogin($store) {
    $store.commit('show_login_modal', { show: true });
  },
  toggleMeasure: function toggleMeasure($store) {
    $store.commit('toggle_measure', { enable: true });
  },
  setLanguage: function setLanguage(lang) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.load(lang, 'static/configuration/locale/' + lang + '.json').then(function (a) {
      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.set(lang);
    }).catch(function (e) {
      return alert('Error loading language file: ' + e);
    });
  },
  printMap: function printMap($store, activeLayers, activeContexts, annotationLayer) {
    $store.commit('set_printing_in_progress', { inProgress: true });

    var printRequest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__layersConfig__["c" /* getPrintRequest */])(activeLayers, activeContexts, __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.locale(), annotationLayer);

    var geoserverUrl = __WEBPACK_IMPORTED_MODULE_2_config__["printApi"].url;
    var request = new XMLHttpRequest();
    request.open('POST', geoserverUrl, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    request.responseType = 'blob';

    request.onload = function () {
      if (request.status === 200) {
        var disposition = request.getResponseHeader('content-disposition');
        var matches = /"([^"]*)"/.exec(disposition);
        var filename = matches != null && matches[1] ? matches[1] : 'map.pdf';

        var blob = new Blob([request.response], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
      }

      $store.commit('set_printing_in_progress', { inProgress: false });
    };
    request.send('spec=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(printRequest)));
  }
});

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = globalConf;

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__I18n__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_kml_file_format_variant_svg__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_kml_file_format_variant_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_kml_file_format_variant_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_pdf_file_format_symbol_svg__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_pdf_file_format_symbol_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_pdf_file_format_symbol_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_layers_svg__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_layers_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_layers_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_feedback_svg__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_feedback_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_feedback_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_ruler_svg__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_ruler_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_ruler_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_user_svg__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_user_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_login_svg__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_login_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_login_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_logout_svg__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_logout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_logout_svg__);





















var customIcons = [['kml', __WEBPACK_IMPORTED_MODULE_11__assets_kml_file_format_variant_svg___default.a], ['pdf', __WEBPACK_IMPORTED_MODULE_12__assets_pdf_file_format_symbol_svg___default.a], ['layers', __WEBPACK_IMPORTED_MODULE_13__assets_layers_svg___default.a], ['feedback', __WEBPACK_IMPORTED_MODULE_14__assets_feedback_svg___default.a], ['ruler', __WEBPACK_IMPORTED_MODULE_15__assets_ruler_svg___default.a], ['user', __WEBPACK_IMPORTED_MODULE_16__assets_user_svg___default.a], ['login', __WEBPACK_IMPORTED_MODULE_17__assets_login_svg___default.a], ['logout', __WEBPACK_IMPORTED_MODULE_18__assets_logout_svg___default.a]];

__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a.register(customIcons.reduce(function (result, _ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      name = _ref2[0],
      icon = _ref2[1];

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, result, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'slms-' + name, {
    width: 512,
    height: 512,
    raw: icon
  }));
}, {}));

var httpGetParams = function () {
  var queryString = {},
      pairs = window.location.search.substring(1).split('&').map(function (v) {
    return v.split('=');
  });

  pairs.forEach(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];

    if (!queryString[k]) {
      queryString[k] = decodeURIComponent(v);
    } else if (typeof queryString[k] === 'string') {
      queryString[k] = [queryString[k], decodeURIComponent(v)];
    } else {
      queryString[k].push(decodeURIComponent(v));
    }
  });
  return queryString;
}();

__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_modal___default.a, {
  dialog: true,
  dynamic: true,
  injectModalsContainer: true
});

__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__I18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);

var languageCodes = __WEBPACK_IMPORTED_MODULE_10_config__["languages"].map(function (l) {
  return l.id;
});
var lang = languageCodes[0];
var navigatorLanguage = navigator.language || navigator.userLanguage;

if (languageCodes.indexOf(httpGetParams.lang) !== -1) lang = httpGetParams.lang;else if (navigatorLanguage && languageCodes.indexOf(navigatorLanguage) !== -1) lang = navigatorLanguage;
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.i18n.set(lang);

var app = new __WEBPACK_IMPORTED_MODULE_5_vue___default.a({
  el: '#app',
  data: { loaded: false },
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

__WEBPACK_IMPORTED_MODULE_5_vue___default.a.i18n.load(lang, 'static/configuration/locale/' + lang + '.json').then(function () {
  app.loaded = true;
}).catch(function (e) {
  return alert('Error loading language file: ' + e);
});

__WEBPACK_IMPORTED_MODULE_8__auth__["a" /* default */].checkAuth();

/***/ }),

/***/ 322:
/***/ (function(module, exports) {


if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      'use strict';

      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function value(predicate) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      var len = o.length >>> 0;

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      var thisArg = arguments[1];

      var k = 0;

      while (k < len) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }

        k++;
      }

      return -1;
    }
  });
}

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);




var Layer = function Layer(layerConfig) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Layer);

  this.id = Layer.nextId++;
  this.originalId = layerConfig.id;
  this.type = layerConfig.type || 'wms';
  this.opacity = 1;

  if (this.type === 'wms') {
    this.serverUrls = layerConfig.serverUrls || __WEBPACK_IMPORTED_MODULE_2_config__["map"].defaultGeoServerURLs;

    this.name = layerConfig.wmsName || layerConfig.name || null;
    this.styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* getLocalizedLabels */])(layerConfig.styles);
    this.imageFormat = layerConfig.imageFormat || 'image/png8';
    this.legend = layerConfig.legend || null;
    this.wmsType = layerConfig.wmsType || 'tiled';

    var tTimes = layerConfig.times || [];
    this.times = tTimes.map(function (time) {
      return {
        iso8601: time,
        humanReadable: time };
    });

    this.statistics = layerConfig.statistics && layerConfig.statistics.map(function (s) {
      var ret = {
        type: s.type,
        labels: s.labels
      };
      switch (s.type) {
        case 'url':
          ret.url = s.url;
          break;
        case 'attributes':
          ret.attributes = s.attributes && s.attributes.map(function (a) {
            return {
              attribute: a.attribute,
              labels: a.labels || a.attribute
            };
          });
          break;
        default:
          throw new Error('Unsupported statistics type: ' + s.type);
      }

      return ret;
    });
    this.downloadLinks = layerConfig.downloadLinks;
  }

  this.visible = layerConfig.visible !== false;
  this.sourceLink = layerConfig.sourceLink || null;
  this.sourceLabel = layerConfig.sourceLabel || null;
};

Layer.nextId = 0;
/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_plurals__ = __webpack_require__(350);






var VuexI18nPlugin = {};

VuexI18nPlugin.install = function (Vue, store) {
  var moduleName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'i18n';
  var identifiers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['{', '}'];

  store.registerModule(moduleName, __WEBPACK_IMPORTED_MODULE_1__i18n_store__["a" /* default */]);

  if (!store.state.hasOwnProperty(moduleName)) {
    console.error('i18n vuex module is not correctly initialized. Please check the module name:', moduleName);

    Vue.prototype.$i18n = function (key) {
      return key;
    };

    Vue.prototype.$getLanguage = function () {
      return null;
    };
    Vue.prototype.$setLanguage = function () {
      return console.error('i18n vuex module is not correctly initialized');
    };

    return;
  }

  var render = renderFn(identifiers);

  var translate = function translate() {
    var locale = store.state[moduleName].locale;

    return translateInLanguage.apply(undefined, [locale].concat(Array.prototype.slice.call(arguments)));
  };

  var translateInLanguage = function translateInLanguage(locale) {
    var key = '';
    var defaultValue = '';
    var options = {};
    var pluralization = null;

    var count = arguments.length;

    if (count >= 3 && typeof arguments[2] === 'string') {
      key = arguments[1];
      defaultValue = arguments[2];

      if (count > 3) options = arguments[3];
      if (count > 4) pluralization = arguments[4];
    } else {
      key = arguments[1];

      defaultValue = key;
      if (count > 2) options = arguments[2];
      if (count > 3) pluralization = arguments[3];
    }

    var translations = store.state[moduleName].translations;

    var fallback = store.state[moduleName].fallback;

    var localeRegional = locale.split('-');

    var translationExist = true;

    if (!translations.hasOwnProperty(locale)) {
      translationExist = false;
    } else if (!translations[locale].hasOwnProperty(key)) {
      translationExist = false;
    }

    if (translationExist) {
      return render(locale, translations[locale][key], options, pluralization);
    }

    if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) && translations[localeRegional[0]].hasOwnProperty(key)) {
      return render(localeRegional[0], translations[localeRegional[0]][key], options, pluralization);
    }

    if (!translations.hasOwnProperty(fallback)) {
      return render(locale, defaultValue, options, pluralization);
    }

    if (!translations[fallback].hasOwnProperty(key)) {
      return render(fallback, defaultValue, options, pluralization);
    }

    return render(locale, translations[fallback][key], options, pluralization);
  };

  var checkKeyExists = function checkKeyExists(key) {
    var locale = store.state[moduleName].locale;
    var fallback = store.state[moduleName].fallback;
    var translations = store.state[moduleName].translations;

    if (!translations.hasOwnProperty(locale)) {
      if (!translations.hasOwnProperty(fallback)) {
        return false;
      }

      return translations[fallback].hasOwnProperty(key);
    }

    return translations[locale].hasOwnProperty(key);
  };

  var setFallbackLocale = function setFallbackLocale(locale) {
    store.dispatch({
      type: 'setFallbackLocale',
      locale: locale
    });
  };

  var setLocale = function setLocale(locale) {
    store.dispatch({
      type: 'setLocale',
      locale: locale
    });
  };

  var getLocale = function getLocale() {
    return store.state[moduleName].locale;
  };

  var addLocale = function addLocale(locale, translations) {
    return store.dispatch({
      type: 'addLocale',
      locale: locale,
      translations: translations
    });
  };

  var loadLocale = function loadLocale(locale, url) {
    return store.dispatch({
      type: 'loadLocale',
      locale: locale,
      url: url
    });
  };

  var removeLocale = function removeLocale(locale) {
    if (store.state[moduleName].translations.hasOwnProperty(locale)) {
      store.dispatch({
        type: 'removeLocale',
        locale: locale
      });
    }
  };

  var checkLocaleExists = function checkLocaleExists(locale) {
    return store.state[moduleName].translations.hasOwnProperty(locale);
  };

  Vue.prototype.$i18n = {
    locale: getLocale,
    set: setLocale,
    add: addLocale,

    load: loadLocale,

    remove: removeLocale,
    fallback: setFallbackLocale,
    localeExists: checkLocaleExists,
    keyExists: checkKeyExists
  };

  Vue.i18n = {
    locale: getLocale,
    set: setLocale,
    add: addLocale,

    load: loadLocale,

    remove: removeLocale,
    fallback: setFallbackLocale,
    translate: translate,
    translateIn: translateInLanguage,
    localeExists: checkLocaleExists,
    keyExists: checkKeyExists
  };

  Vue.prototype.$t = translate;

  Vue.prototype.$te = checkKeyExists;

  Vue.prototype.$tlang = translateInLanguage;

  Vue.filter('translate', translate);
};

var renderFn = function renderFn(identifiers) {
  if (identifiers == null || identifiers.length !== 2) {
    console.warn('You must specify the start and end character identifying variable substitutions');
  }

  var matcher = new RegExp('' + identifiers[0] + '\\w+' + identifiers[1], 'g');

  var replace = function replace(translation, replacements) {
    var warn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!translation.replace) {
      return translation;
    }

    return translation.replace(matcher, function (placeholder) {
      var key = placeholder.replace(identifiers[0], '').replace(identifiers[1], '');

      if (replacements[key] !== undefined) {
        return replacements[key];
      }

      if (warn) {
        console.group('Not all placeholders found');
        console.warn('Text:', translation);
        console.warn('Placeholder:', placeholder);
        console.groupEnd();
      }

      return placeholder;
    });
  };

  var render = function render(locale, translation) {
    var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var pluralization = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var objType = typeof translation === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(translation);
    var pluralizationType = typeof pluralization === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(pluralization);

    var replacedText = function replacedText() {
      if (isArray(translation)) {
        return translation.map(function (item) {
          return replace(item, replacements, false);
        });
      } else if (objType === 'string') {
        return replace(translation, replacements, true);
      }
    };

    if (pluralization === null) {
      return replacedText();
    }

    if (pluralizationType !== 'number') {
      console.warn('pluralization is not a number');
      return replacedText();
    }

    var translatedText = replacedText().split(':::');
    var index = __WEBPACK_IMPORTED_MODULE_2__i18n_plurals__["a" /* default */].getTranslationIndex(locale, pluralization);

    if (typeof translatedText[index] === 'undefined') {
      console.warn('no pluralized translation provided in ', translation);
      return translatedText[0].trim();
    } else {
      return translatedText[index].trim();
    }
  };

  return render;
};

function isArray(obj) {
  return !!obj && Array === obj.constructor;
}

/* harmony default export */ __webpack_exports__["a"] = (VuexI18nPlugin);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  getTranslationIndex: function getTranslationIndex(languageCode, n) {
    switch (languageCode) {
      case 'ay':
      case 'bo':
      case 'cgg':
      case 'dz':
      case 'fa':
      case 'id':
      case 'ja':
      case 'jbo':
      case 'ka':
      case 'kk':
      case 'km':
      case 'ko':
      case 'ky':
      case 'lo':
      case 'ms':
      case 'my':
      case 'sah':
      case 'su':
      case 'th':
      case 'tt':
      case 'ug':
      case 'vi':
      case 'wo':
      case 'zh':
        return 0;
      case 'is':
        return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
      case 'jv':
        return n !== 0 ? 1 : 0;
      case 'mk':
        return n === 1 || n % 10 === 1 ? 0 : 1;
      case 'ach':
      case 'ak':
      case 'am':
      case 'arn':
      case 'br':
      case 'fil':
      case 'fr':
      case 'gun':
      case 'ln':
      case 'mfe':
      case 'mg':
      case 'mi':
      case 'oc':
      case 'pt_BR':
      case 'tg':
      case 'ti':
      case 'tr':
      case 'uz':
      case 'wa':
      case 'zh':
        return n > 1 ? 1 : 0;
      case 'lv':
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2;
      case 'lt':
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
      case 'be':
      case 'bs':
      case 'hr':
      case 'ru':
      case 'sr':
      case 'uk':
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
      case 'mnk':
        return n === 0 ? 0 : n === 1 ? 1 : 2;
      case 'ro':
        return n === 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2;
      case 'pl':
        return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
      case 'cs':
      case 'sk':
        return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
      case 'csb':
        return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
      case 'sl':
        return n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3;
      case 'mt':
        return n === 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;
      case 'gd':
        return n === 1 || n === 11 ? 0 : n === 2 || n === 12 ? 1 : n > 2 && n < 20 ? 2 : 3;
      case 'cy':
        return n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3;
      case 'kw':
        return n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3;
      case 'ga':
        return n === 1 ? 0 : n === 2 ? 1 : n > 2 && n < 7 ? 2 : n > 6 && n < 11 ? 3 : 4;
      case 'ar':
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
      default:
        return n !== 1 ? 1 : 0;
    }
  }
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_plugin__ = __webpack_require__(349);





/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__i18n_store__["a" /* default */],
  plugin: __WEBPACK_IMPORTED_MODULE_1__i18n_plugin__["a" /* default */]
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_source__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_layer__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geosolutions_olgm_layer_Google__ = __webpack_require__(215);









var attributions = [];

var OlLayerFactory = function () {
  function OlLayerFactory() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OlLayerFactory);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OlLayerFactory, null, [{
    key: 'createOlLayer',
    value: function createOlLayer(layerConfig, locale) {
      var source = void 0;
      var sourceType = void 0;

      switch (layerConfig.type) {
        case 'osm':
          source = new __WEBPACK_IMPORTED_MODULE_3_ol_source__["b" /* OSM */]();
          break;
        case 'bing-aerial':
          source = new __WEBPACK_IMPORTED_MODULE_3_ol_source__["c" /* BingMaps */]({
            key: __WEBPACK_IMPORTED_MODULE_5_config__["map"].bingMapsKey,
            imagerySet: 'Aerial'
          });
          break;
        case 'esri':
          source = new __WEBPACK_IMPORTED_MODULE_3_ol_source__["d" /* XYZ */]({
            attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
          });
          break;
        case 'google':
          return new __WEBPACK_IMPORTED_MODULE_6__geosolutions_olgm_layer_Google__["a" /* default */]({
            mapTypeId: 'satellite'
          });
        default:
          var layerAttributions = [],
              sourceLabel = layerConfig.sourceLabel,
              sourceLink = layerConfig.sourceLink,
              attributionKey = sourceLabel || sourceLink,
              wmsType = layerConfig.wmsType || 'tiled';

          if (attributionKey) {
            var attribution = attributions[attributionKey];
            if (!attribution) {
              if (sourceLink) {
                attribution = '<a target="_blank" href="' + sourceLink + '">' + attributionKey + '</a>';
              } else {
                attribution = sourceLabel;
              }
            }
            attributions[attributionKey] = attribution;
            layerAttributions.push(attribution);
          }

          var style = layerConfig.styles && layerConfig.styles.find(function (s) {
            return s.language === locale;
          }).label;
          var sourceConfig = {
            urls: layerConfig.serverUrls,
            params: {
              'LAYERS': layerConfig.name,
              'STYLES': style || undefined,
              'VERSION': '1.3.0',
              'FORMAT': layerConfig.imageFormat,
              'WIDTH': 256,
              'HEIGHT': 256,
              'CRS': 'EPSG:3857'
            },
            serverType: 'geoserver',
            attributions: layerAttributions
          };

          if (wmsType === 'single') {
            source = new __WEBPACK_IMPORTED_MODULE_3_ol_source__["e" /* ImageWMS */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sourceConfig, {
              url: layerConfig.serverUrls[0],
              ratio: 1
            }));
            sourceType = wmsType;
          } else {
            source = new __WEBPACK_IMPORTED_MODULE_3_ol_source__["f" /* TileWMS */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sourceConfig, {
              params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sourceConfig.params, {
                'TILED': true,

                'tilesorigin': '-20037508.34,-20037508.34'
              })
            }));
          }
      }
      if (source) {
        var config = {
          visible: false,
          source: source,
          opacity: layerConfig.opacity || 1
        };
        if (sourceType) return new __WEBPACK_IMPORTED_MODULE_4_ol_layer__["b" /* Image */](config);
        return new __WEBPACK_IMPORTED_MODULE_4_ol_layer__["c" /* Tile */](config);
      }
    }
  }]);

  return OlLayerFactory;
}();

/* harmony default export */ __webpack_exports__["a"] = (OlLayerFactory);

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layersConfig__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layersConfig_util__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layersConfig_context__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layersConfig_group__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_layer_Property__ = __webpack_require__(140);











__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* default */]);

var setContextsTimes = function setContextsTimes(state) {
  var contextsTimes = [];

  state.contexts.forEach(function (c) {
    var times = c.layers.filter(function (l) {
      return l.type === 'wms' && l.times.length;
    }).reduce(function (contextTimes, l) {
      return contextTimes.concat(l.times);
    }, []).filter(function (elem, pos, arr) {
      return arr.findIndex(function (el) {
        return el.iso8601 === elem.iso8601;
      }) === pos;
    }).sort(function (t1, t2) {
      return Date.parse(t1.iso8601) - Date.parse(t2.iso8601);
    });
    c.times = times;
    if (times && times.length) contextsTimes[c.id] = c.times[c.times.length - 1];
  });

  state.contextsTimes = contextsTimes;
};

var annotationStyle = {
  'vector_style': {
    'label': '',
    'fontColor': '#fff',
    'fontFamily': 'sans-serif',
    'fontSize': '12px',
    'fontStyle': 'normal',
    'fontWeight': 'bold',
    'strokeColor': '#ffcc33',
    'strokeOpacity': 1,
    'strokeWidth': 2,
    'fillColor': '#ffffff',
    'fillOpacity': 0.2,
    'strokeDashstyle': 'solid'
  }
};

var state = {
  layers: [],
  contexts: [],
  groups: null,
  annotations: {
    visible: false
  },
  layerInfo: null,
  contextsTimes: [],
  kmlOverlay: null,
  enableFeedback: false,
  measureActive: false,
  activeContextsIds: [],
  activeTool: null,
  appMode: 'desktop',

  editing: false,
  editGroup: null,
  editContext: null,
  editLayers: false,

  showFileDropModal: false,
  showLoginModal: false,
  showUserPanel: false,

  enablePrint: false,
  printingInProgress: false
};

var mutations = {
  enable_edit: function enable_edit(state, _ref) {
    var editing = _ref.editing;

    state.editing = editing;
  },
  add_group: function add_group(state) {
    var newGroup = new __WEBPACK_IMPORTED_MODULE_8__layersConfig_group__["a" /* default */]({
      labels: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__layersConfig_util__["a" /* getLocalizedLabels */])(null, 'New group')
    }, [], state.groups);

    state.groups.items.push(newGroup);
  },
  add_context: function add_context(state) {
    var newContext = new __WEBPACK_IMPORTED_MODULE_7__layersConfig_context__["a" /* default */]({
      labels: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__layersConfig_util__["a" /* getLocalizedLabels */])(null, 'New context')
    });

    newContext.parent = state.groups;
    newContext.times = [];
    state.groups.items.push(newContext);
    state.contexts.push(newContext);
  },
  edit_item: function edit_item(state, _ref2) {
    var id = _ref2.id;

    var item = state.groups.findById(id);

    if (item) {
      if (item.isGroup) state.editGroup = item;else state.editContext = item;
    } else {
      state.editContext = state.editGroup = null;
    }
  },
  delete_item: function delete_item(state, _ref3) {
    var id = _ref3.id;

    var item = state.groups.findById(id);
    var index = item.parent.items.findIndex(function (i) {
      return i.id === id;
    });

    if (index > -1) item.parent.items.splice(index, 1);
  },
  edit_layers: function edit_layers(state, _ref4) {
    var edit = _ref4.edit;

    state.editLayers = edit;
  },
  save_group: function save_group(state, _ref5) {
    var id = _ref5.id,
        labels = _ref5.labels,
        exclusive = _ref5.exclusive,
        allowDisableAll = _ref5.allowDisableAll,
        infoFile = _ref5.infoFile;

    var group = state.groups.findById(id);

    group.labels = labels;
    group.exclusive = exclusive;
    group.allowDisableAll = allowDisableAll;
    group.infoFile = infoFile;
  },
  save_context: function save_context(state, _ref6) {
    var id = _ref6.id,
        label = _ref6.label,
        labels = _ref6.labels,
        infoFile = _ref6.infoFile,
        active = _ref6.active,
        inlineLegendUrl = _ref6.inlineLegendUrl,
        layerIds = _ref6.layerIds;

    var context = state.groups.findById(id);

    context.label = label;
    context.labels = labels;
    context.infoFile = infoFile;
    context.active = active;
    context.inlineLegendUrl = inlineLegendUrl;
    context.layers = layerIds.map(function (id) {
      return state.layers.find(function (layer) {
        return layer.id === id;
      });
    });

    setContextsTimes(state);
  },
  receive_layers: function receive_layers(state, _ref7) {
    var layersConf = _ref7.layersConf;

    state.layers = layersConf.layers;
    state.contexts = layersConf.contexts;
    state.groups = layersConf.groups;

    setContextsTimes(state);

    state.activeContextsIds = state.contexts.reduce(function (a, c) {
      return c.active ? a.concat(c.id) : a;
    }, []);
  },
  update_context: function update_context(state, _ref8) {
    var contextId = _ref8.contextId,
        property = _ref8.property,
        value = _ref8.value;

    var context = state.contexts.find(function (c) {
      return c.id === contextId;
    });

    if (context) {
      context[property] = value;
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9_ol_layer_Property__["a" /* default */]).some(function (p) {
        return p === property;
      })) {
        context.layers.forEach(function (layer) {
          return layer[property] = value;
        });
      }

      state.contexts.splice(contextId, 1, context);
    }
  },
  toggle_context: function toggle_context(state, _ref9) {
    var contextId = _ref9.contextId;

    var context = state.contexts.find(function (c) {
      return c.id === contextId;
    });

    if (context) {
      var idx = state.activeContextsIds.indexOf(contextId);

      if (idx === -1) state.activeContextsIds.push(contextId);else state.activeContextsIds.splice(idx, 1);
    }
  },
  show_layer_info: function show_layer_info(state, _ref10) {
    var fileName = _ref10.fileName,
        label = _ref10.label,
        showDownload = _ref10.showDownload,
        downloadLinks = _ref10.downloadLinks;

    state.layerInfo = { fileName: fileName, label: label, showDownload: showDownload, downloadLinks: downloadLinks };
  },
  set_context_time: function set_context_time(state, _ref11) {
    var contextId = _ref11.contextId,
        time = _ref11.time;

    state.contextsTimes.splice(contextId, 1, time);
  },
  overlay_kml: function overlay_kml(state, _ref12) {
    var kml = _ref12.kml;

    state.kmlOverlay = kml;
  },
  enable_feedback: function enable_feedback(state, _ref13) {
    var enable = _ref13.enable;

    state.enableFeedback = enable;
    state.activeTool = enable ? 'feedback' : null;
  },
  toggle_measure: function toggle_measure(state, _ref14) {
    var enable = _ref14.enable;

    state.activeTool = state.measureActive ? null : 'measure';
    state.measureActive = !state.measureActive;
  },
  update_group: function update_group(state, _ref15) {
    var groupId = _ref15.groupId,
        value = _ref15.value;

    var group = state.groups.findById(groupId);

    if (group) group.items = value;

    group.items.forEach(function (item) {
      item.parent = group;
    });
  },
  update_layers: function update_layers(state, _ref16) {
    var value = _ref16.value;

    state.layers = value;

    state.contexts.forEach(function (context) {
      var contextLayers = context.layers;
      context.layers = contextLayers.map(function (layer) {
        return value.find(function (l) {
          return l.id === layer.id;
        });
      }).filter(function (l) {
        return !!l;
      });
    });

    setContextsTimes(state);
  },
  set_annotations_geojson: function set_annotations_geojson(state, _ref17) {
    var geoJson = _ref17.layer,
        _ref17$label = _ref17.label,
        label = _ref17$label === undefined ? '' : _ref17$label;

    var updatedFeatures = geoJson.features.map(function (f) {
      f.properties = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, f.properties, {
        vector_style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, annotationStyle.vector_style, { label: label })
      });
      return f;
    });
    if (state.annotations.geoJson) {
      var _geoJson$features = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(geoJson.features, 1),
          incomingFeature = _geoJson$features[0];

      var index = state.annotations.geoJson.features.findIndex(function (_ref18) {
        var properties = _ref18.properties;
        return properties.id === incomingFeature.properties.id;
      });
      if (index === -1) {
        state.annotations.geoJson.features.push(incomingFeature);
      } else {
        state.annotations.geoJson.features[index] = incomingFeature;
      }
    } else {
      state.annotations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.annotations, {
        geoJson: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, geoJson, {
          features: updatedFeatures
        })
      });
    }
  },
  set_annotations_visible: function set_annotations_visible(state, _ref19) {
    var visible = _ref19.visible;

    state.annotations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.annotations, { visible: visible });
  },
  clear_annotations: function clear_annotations(state) {
    state.annotations = { visible: false };
  },
  set_application_mode: function set_application_mode(state, _ref20) {
    var _ref20$mode = _ref20.mode,
        mode = _ref20$mode === undefined ? 'desktop' : _ref20$mode;

    state.appMode = mode;
  },
  show_login_modal: function show_login_modal(state, _ref21) {
    var _ref21$show = _ref21.show,
        show = _ref21$show === undefined ? false : _ref21$show;

    state.showLoginModal = show;
  },
  set_enable_print: function set_enable_print(state, _ref22) {
    var _ref22$enable = _ref22.enable,
        enable = _ref22$enable === undefined ? false : _ref22$enable;

    state.enablePrint = enable;
  },
  set_printing_in_progress: function set_printing_in_progress(state, _ref23) {
    var _ref23$inProgress = _ref23.inProgress,
        inProgress = _ref23$inProgress === undefined ? false : _ref23$inProgress;

    state.printingInProgress = inProgress;
  },
  show_file_drop_modal: function show_file_drop_modal(state, _ref24) {
    var _ref24$show = _ref24.show,
        show = _ref24$show === undefined ? false : _ref24$show;

    state.showFileDropModal = show;
    state.activeTool = show ? 'kmlUpload' : null;
  },
  show_user_panel: function show_user_panel(state, _ref25) {
    var _ref25$show = _ref25.show,
        show = _ref25$show === undefined ? false : _ref25$show;

    state.showUserPanel = show;
  },
  set_selected_language: function set_selected_language(state, _ref26) {
    var lang = _ref26.lang;

    state.selectedLanguage = lang;
  },
  show_layer_selector: function show_layer_selector(state, _ref27) {
    var _ref27$show = _ref27.show,
        show = _ref27$show === undefined ? false : _ref27$show;

    state.showLayerSelector = show;
    state.activeTool = show ? 'layerSelector' : null;
  },
  set_active_tool: function set_active_tool(state, _ref28) {
    var tool = _ref28.tool;

    state.activeTool = tool || null;
  }
};

var actions = {
  fetchLayersConfig: function fetchLayersConfig(_ref29) {
    var commit = _ref29.commit;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__layersConfig__["d" /* getLayers */])().then(function (layersConf) {
      return commit('receive_layers', { layersConf: layersConf });
    }).catch(function (error) {
      return alert(error);
    });
  },
  restoreBackup: function restoreBackup(_ref30, _ref31) {
    var dispatch = _ref30.dispatch;
    var version = _ref31.version;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__layersConfig__["e" /* restoreVersion */])(version).then(function () {
      return dispatch('fetchLayersConfig');
    }).catch(function (error) {
      return alert('Server error:\n' + error.statusText);
    });
  }
};

var getters = {
  activeContexts: function activeContexts(state) {
    return state.contexts.filter(function (c) {
      return state.activeContextsIds.indexOf(c.id) !== -1;
    });
  },
  activeLayers: function activeLayers(state, getters) {
    var activeLayers = [];

    getters.activeContexts.forEach(function (context) {
      return context.layers.forEach(function (layer) {
        return activeLayers.push(layer);
      });
    });

    return activeLayers.filter(function (elem, pos, arr) {
      return arr.indexOf(elem) === pos;
    });
  },
  queryableLayers: function queryableLayers(state, getters) {
    return getters.activeLayers.filter(function (layer) {
      return layer.statistics;
    });
  },

  annotationLayer: function annotationLayer(state) {
    return state.annotations.visible && state.annotations.geoJson;
  },
  enableFeedback: function enableFeedback(state) {
    return state.appMode === 'mobile' ? state.activeTool === 'feedback' : state.enableFeedback;
  },
  showFileDropModal: function showFileDropModal(state) {
    return state.appMode === 'mobile' ? state.activeTool === 'kmlUpload' : state.showFileDropModal;
  },
  measureActive: function measureActive(state) {
    return state.appMode === 'mobile' ? state.activeTool === 'measure' : state.measureActive;
  },
  annotationsActive: function annotationsActive(state) {
    return state.appMode !== 'mobile' || state.activeTool === 'annotations';
  },
  layerSelectorActive: function layerSelectorActive(state) {
    return state.groups && (state.appMode !== 'mobile' || state.activeTool === 'layerSelector');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* default */].Store({
  strict: "production" !== 'production',
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Banner__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapPane__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapPane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MapPane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LayerSelector__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LayerSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LayerSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContextInfoModal__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContextInfoModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContextInfoModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FeatureInfo__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FeatureInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_FeatureInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Feedback__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_KMLOverlay__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_KMLOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_KMLOverlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Logos__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Logos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Logos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Measure__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Measure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Measure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Search__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Annotations__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Annotations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Annotations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MobileToolsBar__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MobileToolsBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_MobileToolsBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FileDrop__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FileDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_FileDrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_LoginModal__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_LoginModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_LoginModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__auth__ = __webpack_require__(79);
























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Banner: __WEBPACK_IMPORTED_MODULE_3__components_Banner___default.a,
    MapPane: __WEBPACK_IMPORTED_MODULE_4__components_MapPane___default.a,
    LayerSelector: __WEBPACK_IMPORTED_MODULE_5__components_LayerSelector___default.a,
    ContextInfoModal: __WEBPACK_IMPORTED_MODULE_6__components_ContextInfoModal___default.a,
    FeatureInfo: __WEBPACK_IMPORTED_MODULE_7__components_FeatureInfo___default.a,
    Feedback: __WEBPACK_IMPORTED_MODULE_8__components_Feedback___default.a,
    KMLOverlay: __WEBPACK_IMPORTED_MODULE_9__components_KMLOverlay___default.a,
    Measure: __WEBPACK_IMPORTED_MODULE_11__components_Measure___default.a,
    Logos: __WEBPACK_IMPORTED_MODULE_10__components_Logos___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_12__components_Search___default.a,
    Annotations: __WEBPACK_IMPORTED_MODULE_13__components_Annotations___default.a,
    MobileToolsBar: __WEBPACK_IMPORTED_MODULE_14__components_MobileToolsBar___default.a,
    FileDrop: __WEBPACK_IMPORTED_MODULE_15__components_FileDrop___default.a,
    LoginModal: __WEBPACK_IMPORTED_MODULE_16__components_LoginModal___default.a
  },
  data: function data() {
    return {
      user: __WEBPACK_IMPORTED_MODULE_18__auth__["a" /* default */].user,
      showConsole: false,
      llLogos: __WEBPACK_IMPORTED_MODULE_17_config__["logos"] && __WEBPACK_IMPORTED_MODULE_17_config__["logos"].ll || null,
      resizable: true,
      adaptive: true,
      draggable: true
    };
  },
  created: function created() {
    this.$store.dispatch('fetchLayersConfig');
    if (this.user.authenticated) this.loadEditor();

    this.$store.commit('set_application_mode', { mode: window.screen.width > 768 ? 'desktop' : 'mobile' });
    window.addEventListener('resize', this.resizeHandler);
    this.$store.commit('set_enable_print', { enable: __WEBPACK_IMPORTED_MODULE_17_config__["printApi"] && !!__WEBPACK_IMPORTED_MODULE_17_config__["printApi"].url });
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },

  watch: {
    'user.authenticated': function userAuthenticated() {
      if (this.user.authenticated) this.loadEditor();else this.showConsole = false;
    }
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_17_config__["welcomePage"]) {
      this.showWelcomePage(true, true, true);
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.appMode === 'mobile';
    },
    showLoginModal: function showLoginModal(state) {
      return state.showLoginModal;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['showFileDropModal', 'layerSelectorActive'])),
  methods: {
    resizeHandler: function resizeHandler() {
      this.$store.commit('set_application_mode', { mode: window.screen.width > 768 ? 'desktop' : 'mobile' });
    },
    loadEditor: function loadEditor() {
      var _this = this;

      __webpack_require__.e/* require.ensure */(0).then((function (require) {
        __WEBPACK_IMPORTED_MODULE_1_vue___default.a.component('EditorConsole', __webpack_require__(332));
        _this.showConsole = true;
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    showWelcomePage: function showWelcomePage(resizable, adaptive, draggable) {
      var _this2 = this;

      this.resizable = resizable;
      this.adaptive = adaptive;
      this.draggable = draggable;

      this.$nextTick(function () {
        _this2.$modal.show({
          template: '\n            <div class="iframe-modal-content">\n              <div>Welcome</div>\n              <iframe v-bind:src="iframesrc" width=100% height=100%><b>Welcome to Gonini.org!</b></iframe>\n            </div>\n          ',
          props: ['iframesrc']
        }, {
          iframesrc: __WEBPACK_IMPORTED_MODULE_17_config__["welcomePage"]
        }, {
          transition: 'nice-modal-fade',
          draggable: draggable,
          adaptive: adaptive,
          resizable: resizable,
          width: 0.9 * document.body.clientWidth,
          height: 0.7 * document.body.clientHeight,
          maxWidth: 710,
          maxHeight: 850
        });
      });
    },
    hideFileDropModal: function hideFileDropModal() {
      this.$store.commit('show_file_drop_modal', { show: false });
    },
    hideLoginModal: function hideLoginModal() {
      this.$store.commit('show_login_modal', { show: false });
    }
  }
});

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_angle_down__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_angle_up__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_eye__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_eye_slash__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_trash__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_ol_css__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_ol_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ol_ol_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_style__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_layer_Vector__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_source_Vector__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_format__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_Overlay__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_uuid__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__map__ = __webpack_require__(54);






















var source = void 0;
var layer = void 0;
var interaction = void 0;
var popup = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default.a
  },
  data: function data() {
    var geometryTypes = ['circle', 'triangle', 'rectangle'];

    return {
      curGeomType: geometryTypes[0],
      open: false,
      visible: false,
      geometryTypes: geometryTypes,
      featureText: '',
      id: '',
      currentFeature: {}
    };
  },
  mounted: function mounted() {
    source = new __WEBPACK_IMPORTED_MODULE_12_ol_source_Vector__["a" /* default */]({
      wrapX: false
    });
    layer = new __WEBPACK_IMPORTED_MODULE_11_ol_layer_Vector__["a" /* default */]({
      source: source,
      map: __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */],
      style: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["b" /* Style */]({
        fill: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["d" /* Fill */]({
          color: 'rgba(255,255,255,0.4)'
        }),
        stroke: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["e" /* Stroke */]({
          color: '#ffcc33',
          width: 2
        })
      })
    });
    popup = new __WEBPACK_IMPORTED_MODULE_15_ol_Overlay__["a" /* default */]({
      element: document.getElementById('popup-annotations'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });
    __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].on('click', this.onFeatureClick);
  },

  watch: {
    curGeomType: function curGeomType(_curGeomType) {
      if (this.open) {
        this.createInteraction(_curGeomType);
      }
    },
    annotationsActive: function annotationsActive(_annotationsActive) {
      if (this.open) {
        this.togglePanel();
      }
    },
    open: function open(_open) {
      if (_open) {
        this.createInteraction(this.curGeomType);
      }
    }
  },
  methods: {
    onFeatureClick: function onFeatureClick(e) {
      var feature = __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].forEachFeatureAtPixel(e.pixel, function (feature) {
        return feature || {};
      });
      if (feature) {
        var coordinates = feature.getGeometry().getCoordinates()[0];
        if (coordinates.length) {
          if (feature && feature.getStyle()) this.featureText = feature.getStyle().getText().getText() || '';
          this.currentFeature = feature;
          this.id = feature.getProperties().id;

          __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].addOverlay(popup);
          popup.setPosition(coordinates[0]);
          this.displayPopup(true);
        }
      }
    },
    displayPopup: function displayPopup(show) {
      if (show) document.getElementById('popup-annotations').style.display = 'block';else document.getElementById('popup-annotations').style.display = 'none';
    },
    togglePanel: function togglePanel() {
      var open = !this.open;
      this.open = open;
      if (!open) {
        this.removeInteraction();
      }
    },
    toggleLayer: function toggleLayer() {
      var visible = !layer.getVisible();
      layer.setVisible(visible);
      __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].updateSize();
      this.visible = visible;
      this.$store.commit('set_annotations_visible', { visible: visible });
    },
    showLayer: function showLayer() {
      this.visible = true;
      layer.setVisible(true);
    },
    clearVector: function clearVector() {
      source.clear();
      this.$store.commit('clear_annotations');
      this.visible = false;
    },
    removeInteraction: function removeInteraction() {
      if (interaction) {
        __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].removeInteraction(interaction);
      }
    },
    setFeatureStyle: function setFeatureStyle() {
      var currentFeature = this.currentFeature;
      var text = this.featureText;

      var featureStyle = new __WEBPACK_IMPORTED_MODULE_10_ol_style__["b" /* Style */]({
        fill: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["d" /* Fill */]({
          color: 'rgba(255,255,255,0.4)'
        }),
        stroke: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["e" /* Stroke */]({
          color: '#ffcc33',
          width: 2
        }),
        text: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["f" /* Text */]({
          textAlign: 'center',
          textBaseline: 'middle',
          font: 'bold 16px sans-serif',
          text: text,
          fill: new __WEBPACK_IMPORTED_MODULE_10_ol_style__["d" /* Fill */]({
            color: '#fff'
          }),
          placement: 'point',
          overflow: true
        })
      });
      currentFeature.setStyle(featureStyle);
      currentFeature.setProperties({ id: this.id });

      var geoJSON = JSON.parse(new __WEBPACK_IMPORTED_MODULE_14_ol_format__["a" /* GeoJSON */]().writeFeatures([currentFeature]));
      this.$store.commit('set_annotations_geojson', { layer: geoJSON, label: text });
      this.featureText = '';
      this.displayPopup(false);
    },
    createInteraction: function createInteraction(geomType) {
      var _this = this;

      if (interaction) {
        __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].removeInteraction(interaction);
      }

      var options = void 0;
      switch (geomType) {
        case 'circle':
          options = {
            type: 'Circle',
            geometryFunction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__["a" /* createRegularPolygon */])(0)
          };
          break;
        case 'triangle':
          options = {
            type: 'Circle',
            geometryFunction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__["a" /* createRegularPolygon */])(3)
          };
          break;
        case 'rectangle':
          options = {
            type: 'Circle',
            geometryFunction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__["b" /* createBox */])()
          };
          break;
        default:
          options = null;
      }

      if (options) {
        interaction = new __WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__["c" /* default */](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          source: source
        }, options));
        __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].addInteraction(interaction);
        interaction.on('drawend', function (e) {
          var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_uuid__["a" /* v4 */])();
          e.feature.setProperties({ id: id });
          _this.currentFeature = e.feature;

          var geoJson = new __WEBPACK_IMPORTED_MODULE_14_ol_format__["a" /* GeoJSON */]();
          var features = geoJson.writeFeatures([e.feature]);
          _this.id = id;
          _this.$store.commit('set_annotations_geojson', { layer: JSON.parse(features) });
          _this.$store.commit('set_annotations_visible', { visible: true });
          _this.showLayer();

          _this.featureText = '';

          var _geoJson$readFeatures = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(geoJson.readFeatures(features)[0].getGeometry().getCoordinates()[0], 1),
              coordinate = _geoJson$readFeatures[0];

          __WEBPACK_IMPORTED_MODULE_17__map__["a" /* default */].addOverlay(popup);
          popup.setPosition(coordinate);
          _this.displayPopup(true);
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['annotationsActive']))
});

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_dot_circle_o__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_circle__ = __webpack_require__(220);













/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default.a
  },
  data: function data() {
    return {
      languages: __WEBPACK_IMPORTED_MODULE_2_config__["languages"],
      showUpload: false,
      showLogin: false,
      user: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].user
    };
  },

  methods: {
    setLanguage: function setLanguage(lang) {
      __WEBPACK_IMPORTED_MODULE_4__tools__["a" /* default */].setLanguage(lang);
    },
    enableFeedback: function enableFeedback() {
      __WEBPACK_IMPORTED_MODULE_4__tools__["a" /* default */].enableFeedback(this.$store, true);
    },
    enableUpload: function enableUpload() {
      __WEBPACK_IMPORTED_MODULE_4__tools__["a" /* default */].enableUpload(this.$store, true);
    },
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].logout();
    },
    showLoginDialog: function showLoginDialog() {
      __WEBPACK_IMPORTED_MODULE_4__tools__["a" /* default */].showLogin(this.$store, true);
    },
    toggleMeasure: function toggleMeasure() {
      __WEBPACK_IMPORTED_MODULE_4__tools__["a" /* default */].toggleMeasure(this.$store, true);
    },
    printMap: function printMap() {
      __WEBPACK_IMPORTED_MODULE_4__tools__["a" /* default */].printMap(this.$store, this.activeLayers, this.activeContexts, this.annotationLayer);
    },
    toggleUserPanel: function toggleUserPanel() {
      this.$store.commit('show_user_panel', { show: !this.showUserPanel });
    },
    adminButtonClick: function adminButtonClick() {
      if (!this.user.authenticated) {
        this.showLoginDialog(true);
      } else {
        this.logout();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['activeLayers', 'activeContexts', 'annotationLayer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.appMode === 'mobile';
    },
    selectedLanguage: function selectedLanguage(state) {
      return state.i18n.locale;
    },
    enablePrint: function enablePrint(state) {
      return state.enablePrint;
    },
    showUserPanel: function showUserPanel(state) {
      return state.showUserPanel;
    }
  }))
});

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__httpRequest__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);








var processUrlTemplate = function processUrlTemplate(urlTemplate) {
  return urlTemplate.replace('$(_lang)', __WEBPACK_IMPORTED_MODULE_4_vue___default.a.i18n.locale());
};

var isValidEmail = function isValidEmail(str) {
  var regexp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return regexp.test(str);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showModal: false,
      custom_content: null,
      content: null,
      needsEmail: false,
      email: '',
      emailInvalid: false,
      showDownloadLinks: false
    };
  },

  methods: {
    closeByName: function closeByName() {
      this.$modal.hide('context-info-modal');
    },
    changeEmail: function changeEmail(e) {
      this.email = e.target.value;
    },
    resetState: function resetState() {
      this.email = '';
      this.emailInvalid = false;
      this.content = '';
      this.showDownloadLinks = false;
    },
    showLayerInfoContent: function showLayerInfoContent(val) {
      var _this = this;

      this.label = val.label;

      var showContent = function showContent(content) {
        _this.content = content;
        _this.$modal.show('context-info-modal');
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__httpRequest__["a" /* default */])('GET', processUrlTemplate(val.fileName)).then(function (responseText) {
        return showContent(responseText);
      }).catch(function (error) {
        return showContent('Cannot get layer info:\n' + error.statusText);
      });
    },
    validateEmailAndContinue: function validateEmailAndContinue() {
      if (!isValidEmail(this.email)) {
        this.emailInvalid = true;
      } else {
        var localStorage = window.localStorage;
        localStorage.setItem('userEmail', this.email);

        this.emailInvalid = false;
        this.needsEmail = false;
        this.showDownloadLinks = true;
      }
    },
    requestEmailChange: function requestEmailChange() {
      this.needsEmail = true;
      this.showDownloadLinks = false;
    },
    processDownloadLink: function processDownloadLink(_ref) {
      var url = _ref.url;

      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/layer_info_download_log');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ email: this.email, link: url }));
    }
  },
  watch: {
    layerInfo: function layerInfo(val) {
      if (!val.showDownload) {
        this.showLayerInfoContent(val);
      } else {
        var localStorage = window.localStorage;
        var userEmail = localStorage.getItem('userEmail');

        if (!userEmail) {
          this.needsEmail = true;
          this.$modal.show('context-info-modal');
        } else {
          this.email = userEmail;
          this.needsEmail = false;
          this.showDownloadLinks = true;
          this.$modal.show('context-info-modal');
        }
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['layerInfo']), {
    showEmailPrompt: function showEmailPrompt() {
      return !!this.layerInfo && this.layerInfo.showDownload && this.needsEmail && !this.showDownloadLinks;
    },
    downloadLinksIntl: function downloadLinksIntl() {
      return (this.layerInfo.downloadLinks || []).map(function (d) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, d, { label: d.labels.find(function (l) {
            return l.language === __WEBPACK_IMPORTED_MODULE_4_vue___default.a.i18n.locale();
          }).label });
      });
    }
  })
});

/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    conf: Object
  },
  data: function data() {
    return {
      legendUrls: this.conf.legend(__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.locale())
    };
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_layer_Vector__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_source_Vector__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_Overlay__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_format_GeoJSON__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__map__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__httpRequest__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);














var highlightOverlay = new __WEBPACK_IMPORTED_MODULE_3_ol_layer_Vector__["a" /* default */]({
  source: new __WEBPACK_IMPORTED_MODULE_4_ol_source_Vector__["a" /* default */](),
  map: __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */]
});

var processTemplate = function processTemplate(template, feature) {
  var regex = /\$\((\w+)\)/g;
  return template.replace(regex, function (match, p) {
    var attributeName = match.substring(2, match.length - 1);
    return feature.getProperties()[attributeName];
  });
};

var processUrlTemplate = function processUrlTemplate(urlTemplate, feature) {
  return processTemplate(urlTemplate.replace('$(_lang)', __WEBPACK_IMPORTED_MODULE_10_vue___default.a.i18n.locale()), feature);
};

var parser = new __WEBPACK_IMPORTED_MODULE_6_ol_format_GeoJSON__["a" /* default */]();

var reflect = function reflect(p) {
  return p.then(function (v) {
    return { v: v, layer: p.layer, status: 'fulfilled' };
  }, function (e) {
    return { e: e, layer: p.layer, status: 'rejected' };
  });
};

var container = void 0,
    closer = void 0,
    popup = void 0;

var displayResults = function displayResults(statisticsConfs, statisticsLabels, statisticsFeatures, event, accumulator, result) {
  var features = parser.readFeatures(result.v, { featureProjection: 'EPSG:3857' });

  if (features.length) {
    highlightOverlay.getSource().addFeatures(features);

    features.forEach(function (feature) {
      if (result.layer) {
        var statistics = result.layer.statistics;
        statistics.forEach(function (stat) {
          statisticsConfs.push(stat);
          var template = stat.labels.find(function (l) {
            return l.language === __WEBPACK_IMPORTED_MODULE_10_vue___default.a.i18n.locale();
          }).label;
          statisticsLabels.push(template ? processTemplate(template, feature) : feature.getId());
          statisticsFeatures.push(feature);
        });
      }
    });
  }
  return accumulator + features.length;
};

var clickHandler = function clickHandler(event) {
  if (this.enableFeedback || this.measureActive) {
    return;
  }
  popup.setPosition(undefined);
  highlightOverlay.getSource().clear();

  if (this.queryableLayers.length) {
    this.statisticsConfs = [];
    this.statisticsLabels = [];
    this.statisticsFeatures = [];

    var mapSize = __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].getSize(),
        _mapSize = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(mapSize, 2),
        width = _mapSize[0],
        height = _mapSize[1],
        _event$pixel = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(event.pixel, 2),
        evtx = _event$pixel[0],
        evty = _event$pixel[1],
        extent = __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].getView().calculateExtent(mapSize);


    var infoRequests = [];
    this.queryableLayers.forEach(function (l) {
      var getinfourl = '' + (l.serverUrls && l.serverUrls.length && l.serverUrls[0]) + ('?LAYERS=' + l.name + '&QUERY_LAYERS=' + l.name + '&STYLES=&SERVICE=WMS&VERSION=1.1.1') + ('&REQUEST=GetFeatureInfo&SRS=EPSG%3A900913&BBOX=' + extent.join('%2C') + '&FEATURE_COUNT=5') + ('&FORMAT=image%2Fpng&INFO_FORMAT=application%2Fjson&HEIGHT=' + height + '&WIDTH=' + width) + ('&X=' + Math.round(evtx) + '&Y=' + Math.round(evty) + '&EXCEPTIONS=application%2Fvnd.ogc.se_xml');
      var getInfoRequest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__httpRequest__["a" /* default */])('GET', getinfourl);
      getInfoRequest.layer = l;
      infoRequests.push(getInfoRequest);
    });

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(infoRequests.map(reflect)).then(function (results) {
      var fulfilled = results.filter(function (x) {
        return x.status === 'fulfilled';
      });

      if (fulfilled.reduce(displayResults.bind(null, this.statisticsConfs, this.statisticsLabels, this.statisticsFeatures, event), 0) > 0) {
        popup.setPosition(event.coordinate);
      } else {
        popup.setPosition(undefined);
      }
    }.bind(this));
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      statisticsLabels: [],
      statisticsConfs: [],
      statisticsFeatures: [],
      showStatisticsModal: false,
      statisticsUrl: null,
      popupAttributes: null
    };
  },
  mounted: function mounted() {
    container = document.getElementById('popup');
    closer = document.getElementById('popup-closer');

    closer.onclick = function () {
      popup.setPosition(undefined);
      closer.blur();
      highlightOverlay.getSource().clear();

      return false;
    };

    popup = new __WEBPACK_IMPORTED_MODULE_5_ol_Overlay__["a" /* default */]({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });
    __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].addOverlay(popup);
  },

  watch: {
    layers: {
      immediate: true,
      handler: function handler() {
        if (!this.clickCallback) {
          this.clickCallback = clickHandler.bind(this);
        }

        __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].un('singleclick', this.clickCallback);

        this.handlerKey = __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].on('singleclick', this.clickCallback);
      }
    }
  },
  methods: {
    showStatistics: function showStatistics(statsConf, feature) {
      var attributeLabel = function attributeLabel(attribute) {
        var loc = attribute.labels.find(function (l) {
          return l.language === __WEBPACK_IMPORTED_MODULE_10_vue___default.a.i18n.locale();
        });
        return loc ? loc.label : null;
      };

      switch (statsConf.type) {
        case 'url':
          var url = statsConf.url;
          this.statisticsUrl = processUrlTemplate(url, feature);
          this.$modal.show('stats-modal');
          break;
        case 'attributes':
          var attributes = statsConf.attributes;
          if (attributes) {
            this.popupAttributes = attributes.map(function (a) {
              return {
                label: attributeLabel(a),
                value: feature.getProperties()[a.attribute] || 'n/a'
              };
            });
          } else {
            var t = [],
                properties = feature.getProperties();
            for (var p in properties) {
              if (properties.hasOwnProperty(p) && p !== 'geometry') {
                t.push({ label: p, value: properties[p] });
              }
            }
            this.popupAttributes = t;
          }
          this.$modal.show('props-modal');
          break;
        default:
          break;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['layers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['queryableLayers', 'measureActive', 'enableFeedback']))
});

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_source__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_layer__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_interaction_Draw__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_format_KML__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__map__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_config__);











var drawLayer = null,
    drawInteraction = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      drawSource: null,
      senderEmailIsRequired: __WEBPACK_IMPORTED_MODULE_7_config__["feedbackApi"].askForEmail || false,
      senderEmail: '',
      message: '',
      draw: null,
      categories: __WEBPACK_IMPORTED_MODULE_7_config__["feedbackApi"].feedbackCategories || [],
      selectedCategory: '',
      drawOptions: __WEBPACK_IMPORTED_MODULE_7_config__["feedbackApi"].drawOptions || ['Point', 'Polygon'],
      drawDefault: __WEBPACK_IMPORTED_MODULE_7_config__["feedbackApi"].drawDefault || 'Polygon'
    };
  },

  watch: {
    enableFeedback: function enableFeedback(enable) {
      if (enable) {
        this.drawSource = new __WEBPACK_IMPORTED_MODULE_1_ol_source__["a" /* Vector */]({ wrapX: false });

        drawLayer = new __WEBPACK_IMPORTED_MODULE_2_ol_layer__["a" /* Vector */]({
          source: this.drawSource,
          map: __WEBPACK_IMPORTED_MODULE_6__map__["a" /* default */]
        });
        if (this.drawOptions.includes(this.drawDefault || 'Polygon')) {
          this.draw = this.drawDefault || 'Polygon';
        } else {
          this.draw = this.drawOptions[0];
        }
      } else {
        this.message = '';
        this.selectedCategory = '';
        __WEBPACK_IMPORTED_MODULE_6__map__["a" /* default */].removeInteraction(drawInteraction);
        this.clear();
        __WEBPACK_IMPORTED_MODULE_6__map__["a" /* default */].removeLayer(drawLayer);
        this.draw = null;
      }
    },
    draw: function draw() {
      if (!this.draw) return;

      if (drawInteraction) __WEBPACK_IMPORTED_MODULE_6__map__["a" /* default */].removeInteraction(drawInteraction);
      drawInteraction = new __WEBPACK_IMPORTED_MODULE_3_ol_interaction_Draw__["c" /* default */]({
        source: this.drawSource,
        type: this.draw
      });
      __WEBPACK_IMPORTED_MODULE_6__map__["a" /* default */].addInteraction(drawInteraction);
    }
  },
  methods: {
    setDrawTool: function setDrawTool(type) {
      this.draw = type;
    },
    sendFeedback: function sendFeedback() {
      var allFeatures = drawLayer.getSource().getFeatures(),
          format = new __WEBPACK_IMPORTED_MODULE_4_ol_format_KML__["a" /* default */](),
          kml = format.writeFeatures(allFeatures, { featureProjection: 'EPSG:3857' }),
          xhr = new XMLHttpRequest(),
          _this = this;

      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) alert('Feedback sent');else alert('Error sending feedback\n' + this.responseText);

          _this.disableFeedback();
        }
      };

      var params = 'category=' + this.selectedCategory + '&message=' + this.message + '&kml=' + kml;

      if (__WEBPACK_IMPORTED_MODULE_7_config__["feedbackApi"].askForEmail) {
        params += '&sender=' + this.senderEmail;
      }

      xhr.open('POST', __WEBPACK_IMPORTED_MODULE_7_config__["feedbackApi"].feedbackUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.send(params);
    },
    disableFeedback: function disableFeedback() {
      this.$store.commit('enable_feedback', { enable: false });
    },
    clear: function clear() {
      drawLayer && drawLayer.getSource().clear();
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    drew: function drew() {
      return !!(this.drawSource && this.drawSource.getFeatures().length);
    },
    disableSend: function disableSend() {
      if (this.senderEmailIsRequired && !this.validEmail(this.senderEmail)) {
        return true;
      }

      return !(this.drew && this.message !== '' && !(this.categories.length !== 0 && this.selectedCategory === ''));
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['enableFeedback']))
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Modal__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__Modal___default.a
  },
  props: {
    show: Boolean
  },
  methods: {
    hideUploadPopup: function hideUploadPopup() {
      this.$emit('disable');
    }
  },
  watch: {
    show: function show(_show) {
      var _this = this;

      var counter = 0;

      var dragEnter = function dragEnter(e) {
        e.stopPropagation();
        e.preventDefault();
        counter++;
        document.getElementById('dropTarget').classList.add('dragover');
      };

      var dragLeave = function dragLeave(e) {
        counter--;
        if (counter === 0) {
          document.getElementById('dropTarget').classList.remove('dragover');
        }
      };

      var dragOver = function dragOver(e) {
        e.stopPropagation();
        e.preventDefault();
      };

      var handleFiles = function handleFiles(files) {
        var file = files[0];

        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            _this.$store.commit('overlay_kml', { kml: e.target.result });
          } catch (err) {
            alert('Error reading the KML file:\n' + err);
          }
          _this.hideUploadPopup();
        };
        reader.readAsText(file);
      };

      var drop = function drop(e) {
        e.stopPropagation();
        e.preventDefault();

        var dt = e.dataTransfer,
            files = dt.files;

        handleFiles(files);

        counter = 0;
      };
      if (_show) {
        this.$nextTick(function () {
          var dropTarget = document.getElementById('dropTarget');
          dropTarget.addEventListener('dragenter', dragEnter, false);
          dropTarget.addEventListener('dragleave', dragLeave, false);
          dropTarget.addEventListener('dragover', dragOver, false);
          dropTarget.addEventListener('drop', drop, false);
        });
      }
    }
  }
});

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextLegend__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ContextLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeSelect__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TimeSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_plus_square_o__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_minus_square_o__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_icons_th_list__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_awesome_icons_info_circle__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons_clock_o__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_bar_chart__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome_icons_square__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_check_square__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_circle__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_dot_circle_o__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_pencil_square_o__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_trash_o__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_download__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_awesome_icons_caret_right__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_icons_caret_down__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_awesome_icons_adjust__ = __webpack_require__(354);





























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item',

  components: {
    ContextLegend: __WEBPACK_IMPORTED_MODULE_5__ContextLegend___default.a,
    TimeSelect: __WEBPACK_IMPORTED_MODULE_6__TimeSelect___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a,

    'draggable': function draggable(resolve) {
      return __webpack_require__.e/* require.ensure */(0).then((function (require) {
        return resolve(__webpack_require__(326));
      }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  },

  props: {
    conf: Object
  },

  data: function data() {
    return {
      open: !this.conf.parent,
      showLegend: false,
      showTimeMenu: false,
      highlighted: false,
      opacity: this.conf.opacity
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    list: {
      get: function get() {
        return this.conf.items;
      },
      set: function set(value) {
        this.$store.commit('update_group', { groupId: this.conf.id, value: value });
      }
    },

    label: function label() {
      var loc = this.conf.labels.find(function (l) {
        return l.language === __WEBPACK_IMPORTED_MODULE_3_vue___default.a.i18n.locale();
      });
      return loc ? loc.label : null;
    },
    isRoot: function isRoot() {
      return !this.conf.parent;
    },
    hasLayers: function hasLayers() {
      return !!this.conf.layers && !!this.conf.layers.length;
    },
    hasStatistics: function hasStatistics() {
      return !!this.conf.layers && this.conf.layers.some(function (l) {
        return l.statistics;
      });
    },
    hasDataDownload: function hasDataDownload() {
      return !!this.conf.layers && this.conf.layers.some(function (l) {
        return l.downloadLinks;
      });
    },
    selectedTime: function selectedTime() {
      return this.contextsTimes[this.conf.id];
    },
    active: function active() {
      return this.activeContextsIds.indexOf(this.conf.id) !== -1;
    },
    nContexts: function nContexts() {
      return function count(conf) {
        if (conf.isGroup) {
          return conf.items.reduce(function (n, item) {
            return n + count(item);
          }, 0);
        }
        return conf.layers.length ? 1 : 0;
      }(this.conf);
    },
    nActive: function nActive() {
      var activeContextsIds = this.activeContextsIds;
      return function count(conf) {
        if (conf.isGroup) {
          return conf.items.reduce(function (n, item) {
            return n + count(item);
          }, 0);
        }
        return activeContextsIds.indexOf(conf.id) !== -1 ? 1 : 0;
      }(this.conf);
    },
    locNActive: function locNActive() {
      var locale = __WEBPACK_IMPORTED_MODULE_3_vue___default.a.i18n.locale();
      var lang = __WEBPACK_IMPORTED_MODULE_8_config__["languages"].find(function (l) {
        return l.id === locale;
      });
      if (lang && lang.u) locale += '-u-' + lang.u;

      if ((typeof Intl === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(Intl)) === 'object' && typeof Intl.NumberFormat === 'function') {
        return this.nActive.toLocaleString(locale);
      } else {
        return this.nActive;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])(['contextsTimes', 'activeContextsIds', 'editing'])),

  watch: {
    active: function active() {
      this.showLegend = false;
    }
  },

  methods: {
    startEditing: function startEditing() {
      this.$store.commit('enable_edit', { editing: true });
    },
    editItem: function editItem() {
      this.$store.commit('edit_item', { id: this.conf.id });
    },
    deleteItem: function deleteItem() {
      if (confirm('Are you sure that you want to delete this item?')) {
        this.$store.commit('delete_item', { id: this.conf.id });
      }
    },
    highlightContext: function highlightContext(highlight) {
      this.highlighted = highlight;
    },
    toggleContent: function toggleContent() {
      this.open = !this.open;
    },
    toggleActive: function toggleActive() {
      var _this = this;

      if (this.conf.layers.length) {
        if (!this.conf.parent.exclusive) {
          this.$store.commit('toggle_context', { contextId: this.conf.id });
        } else {
          if (this.conf.parent.allowDisableAll || !this.active) this.$store.commit('toggle_context', { contextId: this.conf.id });
          this.conf.parent.items.forEach(function (item) {
            if (item.id !== _this.conf.id && _this.activeContextsIds.indexOf(item.id) !== -1) {
              _this.$store.commit('toggle_context', { contextId: item.id });
            }
          });
        }
      }
    },
    updateOpacity: function updateOpacity(event) {
      if (this.conf.layers.length) {
        this.$store.commit('update_context', {
          contextId: this.conf.id,
          property: 'opacity',
          value: +event.target.value
        });
      }
    },
    toggleLegend: function toggleLegend() {
      if (this.active) this.showLegend = !this.showLegend;
    },
    showInfo: function showInfo() {
      this.$store.commit('show_layer_info', { label: this.conf.label, fileName: this.conf.infoFile });
    },
    showDownloads: function showDownloads() {
      this.$store.commit('show_layer_info', {
        label: this.label + ' Downloads',
        showDownload: true,
        downloadLinks: (this.conf.layers || []).map(function (l) {
          return l.downloadLinks;
        }).reduce(function (result, cur) {
          return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cur));
        }, [])
      });
    },
    toggleTimeMenu: function toggleTimeMenu() {
      this.showTimeMenu = !this.showTimeMenu;
    },
    setTime: function setTime(time) {
      this.$store.commit('set_context_time', { contextId: this.conf.id, time: time });
    }
  }
});

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_layer_Vector__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_source_Vector__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_style_Fill__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_style_Stroke__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_style_Circle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_format_KML__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__map__ = __webpack_require__(54);












var vectorLayer = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    clearFeedback: function clearFeedback() {
      this.$store.commit('overlay_kml', { kml: null });
    }
  },
  watch: {
    kmlOverlay: function kmlOverlay(kml) {
      __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].removeLayer(vectorLayer);
      if (kml) {
        var vectorSource = new __WEBPACK_IMPORTED_MODULE_1_ol_source_Vector__["a" /* default */]({
          features: new __WEBPACK_IMPORTED_MODULE_6_ol_format_KML__["a" /* default */]({ extractStyles: false }).readFeatures(kml, { featureProjection: 'EPSG:3857' })
        });

        var stroke = new __WEBPACK_IMPORTED_MODULE_4_ol_style_Stroke__["a" /* default */]({
          color: '#319FD3',
          width: 1
        });
        var fill = new __WEBPACK_IMPORTED_MODULE_3_ol_style_Fill__["a" /* default */]({
          color: 'rgba(255, 255, 255, 0.3)'
        });
        var circle = new __WEBPACK_IMPORTED_MODULE_5_ol_style_Circle__["a" /* default */]({
          fill: fill,
          stroke: stroke,
          radius: 5
        });

        var defaultStyle = {
          'Point': new __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__["d" /* default */]({
            image: circle
          }),
          'LineString': new __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__["d" /* default */]({
            stroke: stroke
          }),
          'Polygon': new __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__["d" /* default */]({
            fill: fill,
            stroke: stroke
          }),
          'MultiPoint': new __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__["d" /* default */]({
            image: circle
          }),
          'MultiLineString': new __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__["d" /* default */]({
            stroke: stroke
          }),
          'MultiPolygon': new __WEBPACK_IMPORTED_MODULE_2_ol_style_Style__["d" /* default */]({
            fill: fill,
            stroke: stroke
          })
        };

        var styleFunction = function styleFunction(feature, resolution) {
          var featureStyleFunction = feature.getStyleFunction();
          if (featureStyleFunction) {
            return featureStyleFunction.call(feature, resolution);
          }
          return defaultStyle[feature.getGeometry().getType()];
        };

        vectorLayer = new __WEBPACK_IMPORTED_MODULE_0_ol_layer_Vector__["a" /* default */]({
          source: vectorSource,
          style: styleFunction
        });

        vectorLayer.setZIndex(1000);
        __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].addLayer(vectorLayer);
        __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].getView().fit(vectorSource.getExtent(), __WEBPACK_IMPORTED_MODULE_8__map__["a" /* default */].getSize());
      }
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])(['kmlOverlay'])
});

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(79);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layerSelector',
  components: {
    Item: __WEBPACK_IMPORTED_MODULE_1__Item___default.a
  },
  data: function data() {
    return {
      user: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].user
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    groups: function groups(state) {
      return state.groups;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['layerSelectorActive']))
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: null,
      password: null,
      error: null
    };
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__Modal___default.a
  },
  props: {
    show: Boolean
  },
  methods: {
    submit: function submit(user, password) {
      var _this = this;

      var credentials = {
        username: this.user,
        password: this.password
      };
      __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].login(credentials, 'secretquote').then(function (user) {
        _this.$emit('disable');
        _this.user = _this.password = _this.error = null;
      }).catch(function (error) {
        this.error = error.statusText;
      }.bind(this));
    },
    cancel: function cancel() {
      this.$emit('disable');
      this.user = this.password = this.error = null;
    }
  }
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    logosList: Array
  }
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__olLayerFactory__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__map__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_layer_Property__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__geosolutions_olgm_OLGoogleMaps__ = __webpack_require__(333);












var olLayers = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapPane',
  data: function data() {
    return {
      gmap: null
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_5__map__["a" /* default */].setTarget('map');
    this.gmap = new __WEBPACK_IMPORTED_MODULE_7__geosolutions_olgm_OLGoogleMaps__["a" /* default */]({
      map: __WEBPACK_IMPORTED_MODULE_5__map__["a" /* default */]
    });
  },

  watch: {
    layers: function layers(_layers) {
      __WEBPACK_IMPORTED_MODULE_5__map__["a" /* default */].getLayers().clear();

      _layers.forEach(function (layerConfig) {
        try {
          var olLayer = __WEBPACK_IMPORTED_MODULE_2__olLayerFactory__["a" /* default */].createOlLayer(layerConfig, __WEBPACK_IMPORTED_MODULE_3_vue___default.a.i18n.locale());
          if (olLayer) {
            olLayers[layerConfig.id] = olLayer;
            __WEBPACK_IMPORTED_MODULE_5__map__["a" /* default */].addLayer(olLayer);
          }
        } catch (e) {
          console.log(e);
        }
      });
    },
    locale: function locale(_locale, prev) {
      if (prev !== null) {
        this.layers.forEach(function (layer) {
          if (layer.type !== 'wms') return;
          var oldStyle = layer.styles.find(function (s) {
            return s.language === prev;
          }).label;
          var newStyle = layer.styles.find(function (s) {
            return s.language === _locale;
          }).label;

          if (oldStyle !== newStyle) olLayers[layer.id].getSource().updateParams({ 'STYLES': newStyle });
        });
      }
    },
    activeLayers: function activeLayers(_activeLayers) {
      var setVisibleFunc = function setVisibleFunc(l) {
        var visible = l.visible && _activeLayers.some(function (a) {
          return a.id === l.id;
        });
        olLayers[l.id].setVisible(visible);
      };

      var googleLayers = this.layers.filter(function (l) {
        return l.type === 'google';
      });
      googleLayers.forEach(function (l) {
        return olLayers[l.id].setVisible(false);
      });

      this.layers.filter(function (l) {
        return l.type !== 'google';
      }).forEach(setVisibleFunc);

      googleLayers.forEach(setVisibleFunc);

      if (googleLayers.reduce(function (result, l) {
        return result || olLayers[l.id].getVisible();
      }, false)) {
        this.gmap.activate();
      } else {
        this.gmap.deactivate();
      }
    },
    contextsTimes: function contextsTimes(_contextsTimes) {
      var _this = this;

      var _loop = function _loop(contextId) {
        if (_contextsTimes[contextId]) {
          var context = _this.contexts.find(function (c) {
            return c.id === +contextId;
          });
          context.layers.forEach(function (l) {
            return olLayers[l.id].getSource().updateParams({ 'TIME': _contextsTimes[contextId].iso8601 });
          });
        }
      };

      for (var contextId in _contextsTimes) {
        _loop(contextId);
      }
    },
    contexts: function contexts(_contexts) {
      this.contexts.forEach(function (context) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_6_ol_layer_Property__["a" /* default */]).filter(function (p) {
          return context.hasOwnProperty(p);
        }).forEach(function (p) {
          context.layers.filter(function (l) {
            return l.type !== 'google';
          }).forEach(function (l) {
            olLayers[l.id].set(p, context[p]);
          });
        });
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    'layers': function layers(state) {
      return state.layers;
    },
    'contexts': function contexts(state) {
      return state.contexts;
    },
    'contextsTimes': function contextsTimes(state) {
      return state.contextsTimes;
    },
    'locale': function locale(state) {
      return state.i18n.locale;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['activeLayers']))
});

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_Collection__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_source__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_layer__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_style_Style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_style_Fill__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_style_Stroke__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_style_Circle__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_Overlay__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_geom_Polygon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_geom_LineString__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_Observable__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_sphere__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_format_KML__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__map__ = __webpack_require__(54);




















var drawLayer = null;
var drawInteraction = null;
var typeSelect = void 0;

var ovrlyList = new __WEBPACK_IMPORTED_MODULE_1_ol_Collection__["a" /* default */]();

var source = new __WEBPACK_IMPORTED_MODULE_2_ol_source__["a" /* Vector */]();

var vector = new __WEBPACK_IMPORTED_MODULE_3_ol_layer__["a" /* Vector */]({
  source: source,
  style: new __WEBPACK_IMPORTED_MODULE_4_ol_style_Style__["d" /* default */]({
    fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style_Fill__["a" /* default */]({
      color: 'rgba(255, 255, 255, 0.2)'
    }),
    stroke: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Stroke__["a" /* default */]({
      color: '#ffcc33',
      width: 2
    }),
    image: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Circle__["a" /* default */]({
      radius: 7,
      fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style_Fill__["a" /* default */]({
        color: '#ffcc33'
      })
    })
  })
});

var sketch = void 0;

var helpTooltipElement = void 0;

var helpTooltip = void 0;

var measureTooltipElement = void 0;

var measureTooltip = void 0;

var continuePolygonMsg = 'Click to continue drawing the polygon';

var continueLineMsg = 'Click to continue drawing the line';

var pointerMoveHandler = function pointerMoveHandler(evt) {
  if (evt.dragging) {
    return;
  }

  var helpMsg = 'Click to start drawing';

  if (sketch) {
    var geom = sketch.getGeometry();
    if (geom instanceof __WEBPACK_IMPORTED_MODULE_9_ol_geom_Polygon__["b" /* default */]) {
      helpMsg = continuePolygonMsg;
    } else if (geom instanceof __WEBPACK_IMPORTED_MODULE_10_ol_geom_LineString__["a" /* default */]) {
      helpMsg = continueLineMsg;
    }
  }

  if (helpTooltip) {
    helpTooltipElement.innerHTML = helpMsg;
    helpTooltip.setPosition(evt.coordinate);

    helpTooltipElement.classList.remove('hidden');
  }
};

var formatLength = function formatLength(line) {
  var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_ol_sphere__["c" /* getLength */])(line);
  var output = void 0;
  if (length > 100) {
    output = Math.round(length / 1000 * 100) / 100 + ' ' + 'km';
  } else {
    output = Math.round(length * 100) / 100 + ' ' + 'm';
  }
  return output;
};

var formatArea = function formatArea(polygon) {
  var area = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_ol_sphere__["d" /* getArea */])(polygon);
  var output = void 0;
  if (area > 10000) {
    output = Math.round(area / 1000000 * 100) / 100 + ' ' + 'km<sup>2</sup>';
  } else {
    output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
  }
  return output;
};

var draw = void 0,
    listener = void 0;

function drawStartlistener(evt) {
  sketch = evt.feature;

  var tooltipCoord = evt.coordinate;

  listener = sketch.getGeometry().on('change', function (evt) {
    var geom = evt.target;
    var output = void 0;
    if (geom instanceof __WEBPACK_IMPORTED_MODULE_9_ol_geom_Polygon__["b" /* default */]) {
      output = formatArea(geom);
      tooltipCoord = geom.getInteriorPoint().getCoordinates();
    } else if (geom instanceof __WEBPACK_IMPORTED_MODULE_10_ol_geom_LineString__["a" /* default */]) {
      output = formatLength(geom);
      tooltipCoord = geom.getLastCoordinate();
    }
    measureTooltipElement.innerHTML = output;
    measureTooltip.setPosition(tooltipCoord);
  });
}

function drawEndListener() {
  measureTooltipElement.className = 'tooltip tooltip-static';
  measureTooltip.setOffset([0, -7]);

  sketch = null;

  measureTooltipElement = null;
  createMeasureTooltip();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_ol_Observable__["b" /* unByKey */])(listener);
}

function addInteraction() {
  typeSelect = document.getElementById('measureToolType');

  var type = typeSelect.value === 'area' ? 'Polygon' : 'LineString';
  draw = new __WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__["c" /* default */]({
    source: source,
    type: type,
    style: new __WEBPACK_IMPORTED_MODULE_4_ol_style_Style__["d" /* default */]({
      fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style_Fill__["a" /* default */]({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Stroke__["a" /* default */]({
        color: 'rgba(255,69,0, 0.5)',
        lineDash: [10, 10],
        width: 2
      }),
      image: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Circle__["a" /* default */]({
        radius: 5,
        stroke: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Stroke__["a" /* default */]({
          color: 'rgba(0, 0, 0, 0.7)'
        }),
        fill: new __WEBPACK_IMPORTED_MODULE_5_ol_style_Fill__["a" /* default */]({
          color: 'rgba(255, 255, 255, 0.2)'
        })
      })
    })
  });
  __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].addInteraction(draw);


  draw.on('drawstart', drawStartlistener, this);
  draw.on('drawend', drawEndListener, this);
}

function createHelpTooltip() {
  if (helpTooltipElement) {
    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
  }
  helpTooltipElement = document.createElement('div');
  helpTooltipElement.className = 'tooltip hidden';
  helpTooltip = new __WEBPACK_IMPORTED_MODULE_8_ol_Overlay__["a" /* default */]({
    element: helpTooltipElement,
    offset: [15, 0],
    positioning: 'center-left'
  });
  helpTooltip.setMap(__WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */]);
}

function createMeasureTooltip() {
  if (measureTooltipElement) {
    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
  }
  measureTooltipElement = document.createElement('div');
  measureTooltipElement.className = 'tooltip tooltip-measure';
  measureTooltip = new __WEBPACK_IMPORTED_MODULE_8_ol_Overlay__["a" /* default */]({
    element: measureTooltipElement,
    offset: [0, -15],
    positioning: 'bottom-center'
  });

  measureTooltip.setMap(__WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */]);
  ovrlyList.push(measureTooltip);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$nextTick(function () {
      createMeasureTooltip();
      createHelpTooltip();
    });
  },
  watch: {
    measureActive: function measureActive(enable) {
      if (enable) {
        addInteraction();
        if (pointerMoveHandler && vector) {
          vector.setMap(__WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */]);
          helpTooltip.setMap(__WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */]);
          measureTooltip.setMap(__WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */]);
          __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].on('pointermove', pointerMoveHandler);

          if (typeSelect) typeSelect.classList.remove('hidden');
          document.getElementById('measureOptions').classList.remove('hidden');
          if (helpTooltipElement) helpTooltipElement.classList.remove('hidden');
        }
      } else {
        vector.setMap(null);
        source.clear();
        helpTooltip.setMap(null);
        measureTooltip.setMap(null);
        __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].removeInteraction(draw);

        __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].un('pointermove', pointerMoveHandler);
        if (typeSelect) typeSelect.classList.add('hidden');
        document.getElementById('measureOptions').classList.add('hidden');
        if (helpTooltipElement) {
          helpTooltipElement.classList.add('hidden');
        }

        draw.un('drawstart', drawStartlistener);
        draw.un('drawend', drawEndListener);

        ovrlyList.forEach(function (o) {
          o.setMap(null);
        });
      }
    },
    draw: function draw() {
      if (!this.draw) return;

      if (drawInteraction) __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].removeInteraction(drawInteraction);
      drawInteraction = new __WEBPACK_IMPORTED_MODULE_13_ol_interaction_Draw__["c" /* default */]({
        source: this.drawSource,
        type: this.draw
      });
      __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].addInteraction(drawInteraction);
    }
  },
  methods: {
    setDrawTool: function setDrawTool(type) {
      this.draw = type;
    },
    sendFeedback: function sendFeedback() {
      var allFeatures = drawLayer.getSource().getFeatures(),
          format = new __WEBPACK_IMPORTED_MODULE_14_ol_format_KML__["a" /* default */](),
          kml = format.writeFeatures(allFeatures, { featureProjection: 'EPSG:3857' }),
          xhr = new XMLHttpRequest(),
          _this = this;

      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) alert('Feedback sent');else alert('Error sending feedback\n' + this.responseText);

          _this.disableFeedback();
        }
      };

      var params = 'category=' + this.selectedCategory + '&message=' + this.message + '&kml=' + kml;

      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.send(params);
    },
    disableFeedback: function disableFeedback() {
      this.$store.commit('enable_feedback', { enable: false });
    },
    clear: function clear() {
      drawLayer.getSource().clear();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    drew: function drew() {
      return !!(this.drawSource && this.drawSource.getFeatures().length);
    },
    disableSend: function disableSend() {
      return !(this.drew && this.message !== '' && this.selectedCategory !== '');
    },
    toolTypeSelected: {
      get: function get() {
        return 'length';
      },
      set: function set(optionValue) {
        __WEBPACK_IMPORTED_MODULE_16__map__["a" /* default */].removeInteraction(draw);
        draw.un('drawstart', drawStartlistener);
        draw.un('drawend', drawEndListener);
        addInteraction();
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* mapGetters */])(['measureActive']))
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_Geolocation__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_Feature__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_geom_Point__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_style__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_layer_Vector__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_sticky_note__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons_map_marker__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tools__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__map__ = __webpack_require__(54);


















var geolocation = void 0;
var locationLayer = void 0;
var accuracyFeature = void 0;
var positionFeature = void 0;
var positionChanged = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon___default.a
  },
  data: function data() {
    return {
      locationActive: false,
      gettingLocation: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    geolocation = new __WEBPACK_IMPORTED_MODULE_3_ol_Geolocation__["a" /* default */]({
      trackingOptions: {
        enableHighAccuracy: true
      },
      projection: __WEBPACK_IMPORTED_MODULE_12__map__["a" /* default */].getView().getProjection()
    });
    geolocation.on('error', function (e) {
      _this.gettingLocation = false;
      alert(e.message);
    });

    accuracyFeature = new __WEBPACK_IMPORTED_MODULE_4_ol_Feature__["a" /* default */]();
    geolocation.on('change:accuracyGeometry', function () {
      return accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
    });

    positionFeature = new __WEBPACK_IMPORTED_MODULE_4_ol_Feature__["a" /* default */]();
    positionFeature.setStyle(new __WEBPACK_IMPORTED_MODULE_6_ol_style__["b" /* Style */]({
      image: new __WEBPACK_IMPORTED_MODULE_6_ol_style__["c" /* Circle */]({
        radius: 6,
        fill: new __WEBPACK_IMPORTED_MODULE_6_ol_style__["d" /* Fill */]({
          color: '#3399CC'
        }),
        stroke: new __WEBPACK_IMPORTED_MODULE_6_ol_style__["e" /* Stroke */]({
          color: '#fff',
          width: 2
        })
      })
    }));
    geolocation.on('change:position', function () {
      var coordinates = geolocation.getPosition();
      positionFeature.setGeometry(coordinates ? new __WEBPACK_IMPORTED_MODULE_5_ol_geom_Point__["a" /* default */](coordinates) : null);

      if (!positionChanged) {
        __WEBPACK_IMPORTED_MODULE_12__map__["a" /* default */].getView().setCenter(coordinates);
        positionChanged = true;
      }
      if (_this.gettingLocation) {
        _this.gettingLocation = false;
      }
    });

    locationLayer = new __WEBPACK_IMPORTED_MODULE_7_ol_layer_Vector__["a" /* default */]({
      map: __WEBPACK_IMPORTED_MODULE_12__map__["a" /* default */],
      source: new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
        features: [accuracyFeature, positionFeature]
      })
    });

    locationLayer.setVisible(false);
  },

  methods: {
    printMap: function printMap() {
      __WEBPACK_IMPORTED_MODULE_11__tools__["a" /* default */].printMap(this.$store, this.activeLayers, this.activeContexts, this.annotationLayer);
    },
    toggleTool: function toggleTool(tool) {
      this.$store.commit('set_active_tool', { tool: tool === this.activeTool ? null : tool });
    },
    toggleLocation: function toggleLocation() {
      this.locationActive = !this.locationActive;
    },
    activeClass: function activeClass(tool) {
      return {
        'icon-active': tool === this.activeTool
      };
    }
  },
  watch: {
    locationActive: function locationActive(_locationActive) {
      if (_locationActive) {
        positionChanged = false;
        this.gettingLocation = true;
      } else {
        accuracyFeature.setGeometry();
        positionFeature.setGeometry();
      }
      locationLayer.setVisible(_locationActive);
      geolocation.setTracking(_locationActive);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    tools: function tools() {
      return __WEBPACK_IMPORTED_MODULE_11__tools__["a" /* default */];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['activeLayers', 'activeContexts', 'annotationLayer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.appMode === 'mobile';
    },
    enablePrint: function enablePrint(state) {
      return state.enablePrint;
    },
    activeTool: function activeTool(state) {
      return state.activeTool;
    },
    printingInProgress: function printingInProgress(state) {
      return state.printingInProgress;
    }
  }))
});

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    window.addEventListener('keydown', this.handleKeyDown);
  },

  methods: {
    handleKeyDown: function handleKeyDown(e) {
      if (e.keyCode === 13 || e.keyCode === 27) this.$emit('close');
    }
  }
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__httpRequest__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResult__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_proj__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_format_GeoJSON__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_config__);












/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchText: '',
      results: [],
      wfsSearchConfig: __WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"]
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  watch: {},
  methods: {
    clickHandler: function clickHandler(clickedObject) {
      if (clickedObject && clickedObject.extent) {
        __WEBPACK_IMPORTED_MODULE_4__map__["a" /* default */].getView().fit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ol_proj__["o" /* transformExtent */])(clickedObject.extent, 'EPSG:4326', 'EPSG:3857'), {
          size: __WEBPACK_IMPORTED_MODULE_4__map__["a" /* default */].getSize(),
          maxZoom: 19
        });
      }
    },
    goSearching: function goSearching(e) {
      if (e.keyCode === 13) {
        this.wfsSearch(this.searchText);
      }
    },
    noop: function noop() {},
    wfsSearch: function wfsSearch(searchterm) {
      var _this = this;

      if (!__WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"] || !__WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].layersToQuery) {
        alert('WFS Search is not correctly configured.\nPlease contact your system administrator');
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].layersToQuery.lenght !== __WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].attributesToFilter.lenght) {
        alert('WFS Search attributes list lenght does not match the number of layers to query.\nPlease contact your system administrator');
        return;
      }
      var typeNameList = __WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].layersToQuery.join();
      var cqlFilterString = encodeURI(__WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].attributesToFilter.join(' ILIKE \'%' + searchterm + '%\';') + ' ILIKE \'%' + searchterm + '%\'');
      var params = 'outputFormat=application/json&maxfeatures=10&typeName=' + typeNameList + '&cql_filter=' + cqlFilterString;
      var url = __WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].baseURL + '?service=WFS&version=1.1.0&request=GetFeature&' + params;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__httpRequest__["a" /* default */])('GET', url).then(function (response) {
        var wfsResponse = JSON.parse(response);

        if (wfsResponse.features) {
          _this.results = [];
          var geojsonReader = new __WEBPACK_IMPORTED_MODULE_6_ol_format_GeoJSON__["a" /* default */]();
          wfsResponse.features.forEach(function (element) {
            if (element.geometry && element.geometry.coordinates && element.properties && element.id) {
              var newres = {};
              __WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].layersToQuery.forEach(function (layer, idx) {
                var featureTypeString = layer.indexOf(':') > -1 ? layer.split(':')[1] : layer;
                if (element.id.indexOf(featureTypeString) > -1) {
                  newres.fromtable = layer;
                  if (!newres.title || newres.title.indexOf(searchterm) === -1) {
                    newres.title = element.properties[__WEBPACK_IMPORTED_MODULE_7_config__["wfsSearchConfig"].attributesToFilter[idx]];
                  }
                }
              });
              newres.extent = geojsonReader.readFeature(element).getGeometry().getExtent();
              this.results.push(newres);
            }
          }, _this);
        }
      }).catch(function (err) {
        alert('Error WFS\n' + err);
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.appMode === 'mobile';
    },
    measure: function measure(state) {
      return state.activeTool === 'measure';
    }
  })),
  components: {
    'search-results': __WEBPACK_IMPORTED_MODULE_3__SearchResult___default.a
  }
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['result', 'clickHandler']
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    times: Array,
    selectedTime: Object
  },
  methods: {
    set: function set(time) {
      this.$emit('setTime', time);
    }
  }
});

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_Map__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_View__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_control_MousePosition__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_control__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_coordinate__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_proj__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__geosolutions_olgm_interaction__ = __webpack_require__(346);









var mousePositionControl = new __WEBPACK_IMPORTED_MODULE_2_ol_control_MousePosition__["a" /* default */]({
  coordinateFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_coordinate__["a" /* createStringXY */])(4),
  projection: 'EPSG:4326',
  undefinedHTML: '&nbsp;'
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_ol_Map__["a" /* default */]({
  interactions: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__geosolutions_olgm_interaction__["a" /* defaults */])(),
  controls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_control__["a" /* defaults */])({
    attribution: false,
    zoom: true
  }).extend([mousePositionControl]).extend([new __WEBPACK_IMPORTED_MODULE_3_ol_control__["b" /* Attribution */]({
    collapsible: false
  })]),
  view: new __WEBPACK_IMPORTED_MODULE_1_ol_View__["a" /* default */]({
    center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ol_proj__["a" /* fromLonLat */])(__WEBPACK_IMPORTED_MODULE_6_config__["map"].mapCenterLonLat || [0, 0]),
    zoom: __WEBPACK_IMPORTED_MODULE_6_config__["map"].mapZoom || 4
  })
}));

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"__1Ou0F8s__Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 511.992 511.992\" style=\"enable-background:new 0 0 511.992 511.992;\" xml:space=\"preserve\"><g><g><path d=\"M486.417,140.796H179.166c-14.097,0-25.574,11.477-25.574,25.574v204.851c0,14.097,11.477,25.574,25.574,25.574h192.76 l82.833,82.833c1.638,1.63,3.823,2.5,6.042,2.5c1.101,0,2.21-0.205,3.26-0.649c3.183-1.314,5.265-4.437,5.265-7.885v-76.8h17.092 c14.106,0,25.574-11.477,25.574-25.574V166.37C511.991,152.273,500.514,140.796,486.417,140.796z M494.933,371.221 c0,4.693-3.823,8.508-8.508,8.508H460.8c-4.71,0-8.533,3.814-8.533,8.533v64.734L381.5,382.229c-1.596-1.604-3.772-2.5-6.033-2.5 H179.174c-4.693,0-8.508-3.814-8.508-8.508V166.37c0-4.693,3.814-8.508,8.508-8.508h307.251c4.693,0,8.508,3.814,8.508,8.508 V371.221z\"></path></g></g><g><g><path d=\"M332.826,29.862H25.574C11.477,29.862,0,41.34,0,55.437v204.851c0,14.097,11.477,25.574,25.574,25.574h17.092v76.8 c0,3.447,2.082,6.571,5.274,7.885c1.05,0.444,2.159,0.649,3.26,0.649c2.219,0,4.403-0.87,6.033-2.5l82.842-82.833h22.059 c4.71,0,8.533-3.814,8.533-8.533V166.37c0-4.693,3.814-8.508,8.508-8.508h170.692c4.71,0,8.533-3.814,8.533-8.533V55.437 C358.4,41.34,346.923,29.862,332.826,29.862z M341.333,140.796H179.174c-14.097,0-25.574,11.477-25.574,25.574v102.426h-17.067 c-2.261,0-4.429,0.896-6.033,2.5l-70.767,70.767v-64.734c0-4.719-3.823-8.533-8.533-8.533H25.574 c-4.693,0-8.508-3.814-8.508-8.508V55.437c0-4.693,3.814-8.508,8.508-8.508h307.251c4.693,0,8.508,3.814,8.508,8.508V140.796z\"></path></g></g><g><g><path d=\"M332.8,226.129c-23.526,0-42.667,19.14-42.667,42.667c0,23.526,19.14,42.667,42.667,42.667 c23.526,0,42.667-19.14,42.667-42.667C375.467,245.269,356.326,226.129,332.8,226.129z M332.8,294.396 c-14.114,0-25.6-11.486-25.6-25.6c0-14.114,11.486-25.6,25.6-25.6c14.114,0,25.6,11.486,25.6,25.6 C358.4,282.91,346.914,294.396,332.8,294.396z\"></path></g></g><g><g><path d=\"M435.2,226.129c-23.526,0-42.667,19.14-42.667,42.667c0,23.526,19.14,42.667,42.667,42.667 c23.526,0,42.667-19.14,42.667-42.667C477.867,245.269,458.726,226.129,435.2,226.129z M435.2,294.396 c-14.114,0-25.6-11.486-25.6-25.6c0-14.114,11.486-25.6,25.6-25.6s25.6,11.486,25.6,25.6 C460.8,282.91,449.314,294.396,435.2,294.396z\"></path></g></g><g><g><path d=\"M230.4,226.129c-23.526,0-42.667,19.14-42.667,42.667c0,23.526,19.14,42.667,42.667,42.667 c23.526,0,42.667-19.14,42.667-42.667C273.067,245.269,253.926,226.129,230.4,226.129z M230.4,294.396 c-14.114,0-25.6-11.486-25.6-25.6c0-14.114,11.486-25.6,25.6-25.6s25.6,11.486,25.6,25.6 C256,282.91,244.514,294.396,230.4,294.396z\"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>"

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"__nd4vx_d__Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 550.801 550.801\" style=\"enable-background:new 0 0 550.801 550.801;\" xml:space=\"preserve\"><g><g><path d=\"M475.095,132c-0.031-2.529-0.828-5.023-2.562-6.995L366.325,3.694c-0.021-0.031-0.053-0.042-0.085-0.074 c-0.633-0.709-1.36-1.292-2.141-1.803c-0.232-0.153-0.464-0.288-0.707-0.422c-0.686-0.369-1.392-0.67-2.13-0.892 c-0.2-0.061-0.38-0.14-0.58-0.195C359.87,0.119,359.048,0,358.204,0H97.2c-11.907,0-21.6,9.695-21.6,21.601v507.6 c0,11.913,9.692,21.601,21.6,21.601h356.4c11.918,0,21.6-9.688,21.6-21.601V133.21C475.2,132.804,475.137,132.398,475.095,132z M180.149,512.721l-27.382-48.289l-9.624,11.792v36.503h-25.054V400.882h25.054v49.438h0.504c2.489-4.313,5.139-8.29,7.636-12.271 l25.384-37.167H207.7l-37.007,47.624l38.995,64.215H180.149z M316.206,512.721l-1.655-42.814 c-0.496-13.438-1.002-29.7-1.002-45.964h-0.496c-3.485,14.275-8.126,30.206-12.44,43.311l-13.61,43.644h-19.746l-11.944-43.311 c-3.649-13.11-7.462-29.047-10.125-43.644h-0.335c-0.665,15.104-1.16,32.353-1.985,46.296l-1.994,42.478h-23.398l7.137-111.839 h33.687l10.95,37.336c3.483,12.94,6.966,26.884,9.455,39.982h0.498c3.154-12.936,6.972-27.717,10.621-40.157l11.944-37.167h33.022 l6.138,111.839h-24.722V512.721z M430.191,512.721h-69.867V400.882h25.392v90.603h44.476V512.721z M97.2,366.758V21.605h250.204 v110.519c0,5.961,4.83,10.8,10.8,10.8h95.396l0.011,223.834H97.2z\"></path><g><path d=\"M272.025,64.505c72.452-0.276,132.891,59.034,132.748,132.92c-0.143,72.101-59.542,133.046-133.855,132.481 c-72.839-0.559-131.662-61.606-131.425-133.312C139.736,124.137,199.476,64.299,272.025,64.505z M154.462,161.196 c0.433,0.309,0.865,0.606,1.295,0.912c1.313-0.794,2.734-1.463,3.91-2.418c2.618-2.138,5.07-4.498,7.673-6.657 c15.617-12.968,32.616-16.757,51.371-7.317c6.344,3.19,12.696,6.516,18.602,10.437c26.109,17.328,51.671,35.521,78.208,52.165 c20.999,13.181,43.87,22.61,68.46,27.382c3.797,0.741,5.5-0.253,6.223-3.644c0.991-4.617,1.566-9.337,2.816-13.877 c0.833-2.987-0.274-4.095-2.812-4.688c-13.072-3.082-25.069-8.878-35.495-17.01c-19.068-14.881-37.6-30.478-56.083-46.105 c-12.788-10.826-24.94-22.409-37.687-33.302c-17.305-14.769-37.589-17.497-59.173-13.176c-5.329,1.062-11.588,2.252-15.325,5.664 c-12.852,11.752-23.042,25.716-29.133,42.282C156.189,154.895,155.4,158.08,154.462,161.196z M373.513,266.599 c-0.49-0.529-0.976-1.046-1.472-1.576c-1.571,0.396-3.143,0.757-4.703,1.184c-16.675,4.567-33.598,8.564-50.899,7.699 c-14.939-0.751-29.922-2.787-44.624-5.579c-25.423-4.831-48.977-15.414-72.792-25.196c-7.538-3.093-15.704-5.762-23.738-6.308 c-10.747-0.732-16.648,10.136-11.541,19.42c12.01,21.821,29.049,38.586,51.073,50.229c1.767,0.928,3.786,1.371,6.692,2.399 c-0.583-2.896-0.839-4.52-1.237-6.097c-2.917-11.585,1.814-16.437,13.687-13.99c1.653,0.343,3.312,0.675,4.952,1.107 c28.571,7.372,57.43,10.821,86.872,6.381c15.562-2.352,30.786-5.374,40.526-19.723 C368.608,273.154,371.113,269.903,373.513,266.599z M236.931,79.748c0.087,0.707,0.171,1.405,0.258,2.112 c1.237,0.206,2.463,0.546,3.7,0.604c6.415,0.358,12.83,0.585,19.24,0.973c23.457,1.421,44.149,9.851,60.054,27.108 c12.355,13.387,22.744,28.582,34.383,42.654c5.136,6.225,10.815,12.139,16.954,17.378c4.614,3.937,10.172,3.375,14.074,0.192 c4.262-3.478,4.947-6.787,2.769-13.239c-7.693-22.805-21.151-41.7-40.136-56.252c-27.527-21.12-58.725-30.048-93.379-25.444 C248.817,76.631,242.903,78.419,236.931,79.748z\"></path></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>"

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"__33xIh3F__Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 54.953 54.953\" style=\"enable-background:new 0 0 54.953 54.953;\" xml:space=\"preserve\"><path d=\"M45.297,21.946l9.656-5.517L27.477,0.825L0,16.429l9.656,5.517L0,27.429l9.656,5.517L0,38.429l27.477,15.698l27.476-15.698 l-9.656-5.483l9.656-5.517L45.297,21.946z M27.477,3.125l23.435,13.309l-23.435,13.39L4.041,16.434L27.477,3.125z M11.675,23.099 l15.802,9.028l15.802-9.028l7.633,4.335l-23.435,13.39L4.041,27.434L11.675,23.099z M50.912,38.434l-23.435,13.39L4.041,38.434 l7.634-4.335l15.802,9.028l15.802-9.028L50.912,38.434z\"></path><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>"

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__3pPfvvc__Capa_1\" enable-background=\"new 0 0 551.13 551.13\" viewBox=\"0 0 551.13 551.13\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m499.462 0h-378.902c-9.52 0-17.223 7.703-17.223 17.223v51.668h34.446v-34.445h344.456v482.239h-344.456v-34.446h-34.446v51.668c0 9.52 7.703 17.223 17.223 17.223h378.902c9.52 0 17.223-7.703 17.223-17.223v-516.684c0-9.52-7.704-17.223-17.223-17.223z\"></path><path d=\"m204.588 366.725 24.354 24.354 115.514-115.514-115.514-115.514-24.354 24.354 73.937 73.937h-244.079v34.446h244.08z\"></path></svg>"

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1QdHuBV__Capa_1\" enable-background=\"new 0 0 551.13 551.13\" viewBox=\"0 0 551.13 551.13\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m435.616 160.051-24.354 24.354 73.937 73.937h-244.08v34.446h244.08l-73.937 73.937 24.354 24.354 115.514-115.514z\"></path><path d=\"m378.902 516.685h-344.456v-482.239h344.456v34.446h34.446v-51.669c0-9.52-7.703-17.223-17.223-17.223h-378.902c-9.52 0-17.223 7.703-17.223 17.223v516.684c0 9.52 7.703 17.223 17.223 17.223h378.902c9.52 0 17.223-7.703 17.223-17.223v-51.668h-34.446z\"></path></svg>"

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"__1l5lZyL__Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 550.801 550.801\" style=\"enable-background:new 0 0 550.801 550.801;\" xml:space=\"preserve\"><g><g><path d=\"M267.342,414.698c-6.613,0-10.884,0.585-13.413,1.165v85.72c2.534,0.586,6.616,0.586,10.304,0.586 c26.818,0.189,44.315-14.576,44.315-45.874C308.738,429.079,292.803,414.698,267.342,414.698z\"></path><path d=\"M152.837,414.313c-6.022,0-10.104,0.58-12.248,1.16v38.686c2.531,0.58,5.643,0.78,9.903,0.78 c15.757,0,25.471-7.973,25.471-21.384C175.964,421.506,167.601,414.313,152.837,414.313z\"></path><path d=\"M475.095,131.992c-0.032-2.526-0.833-5.021-2.568-6.993L366.324,3.694c-0.021-0.034-0.062-0.045-0.084-0.076 c-0.633-0.707-1.36-1.29-2.141-1.804c-0.232-0.15-0.475-0.285-0.718-0.422c-0.675-0.366-1.382-0.67-2.13-0.892 c-0.19-0.058-0.38-0.14-0.58-0.192C359.87,0.114,359.037,0,358.203,0H97.2C85.292,0,75.6,9.693,75.6,21.601v507.6 c0,11.913,9.692,21.601,21.6,21.601H453.6c11.908,0,21.601-9.688,21.601-21.601V133.202 C475.2,132.796,475.137,132.398,475.095,131.992z M193.261,463.873c-10.104,9.523-25.072,13.806-42.569,13.806 c-3.882,0-7.391-0.2-10.102-0.58v46.839h-29.35V394.675c9.131-1.55,21.967-2.721,40.047-2.721 c18.267,0,31.292,3.501,40.036,10.494c8.363,6.612,13.985,17.497,13.985,30.322C205.308,445.605,201.042,456.49,193.261,463.873z M318.252,508.392c-13.785,11.464-34.778,16.906-60.428,16.906c-15.359,0-26.238-0.97-33.637-1.94V394.675 c10.887-1.74,25.083-2.721,40.046-2.721c24.867,0,41.004,4.472,53.645,13.995c13.61,10.109,22.164,26.241,22.164,49.37 C340.031,480.4,330.897,497.697,318.252,508.392z M439.572,417.225h-50.351v29.932h47.039v24.11h-47.039v52.671H359.49V392.935 h80.082V417.225z M97.2,366.752V21.601h250.203v110.515c0,5.961,4.831,10.8,10.8,10.8H453.6l0.011,223.836H97.2z\"></path><path d=\"M386.205,232.135c-0.633-0.059-15.852-1.448-39.213-1.448c-7.319,0-14.691,0.143-21.969,0.417 c-46.133-34.62-83.919-69.267-104.148-88.684c0.369-2.138,0.623-3.828,0.741-5.126c2.668-28.165-0.298-47.179-8.786-56.515 c-5.558-6.101-13.721-8.131-22.233-5.806c-5.286,1.385-15.071,6.513-18.204,16.952c-3.459,11.536,2.101,25.537,16.708,41.773 c0.232,0.246,5.189,5.44,14.196,14.241c-5.854,27.913-21.178,88.148-28.613,117.073c-17.463,9.331-32.013,20.571-43.277,33.465 l-0.738,0.844l-0.477,1.013c-1.16,2.437-6.705,15.087-2.542,25.249c1.901,4.62,5.463,7.995,10.302,9.767l1.297,0.349 c0,0,1.17,0.253,3.227,0.253c9.01,0,31.25-4.735,43.179-48.695l2.89-11.138c41.639-20.239,93.688-26.768,131.415-28.587 c19.406,14.391,38.717,27.611,57.428,39.318l0.611,0.354c0.907,0.464,9.112,4.515,18.721,4.524l0,0 c13.732,0,23.762-8.427,27.496-23.113l0.189-1.004c1.044-8.393-1.065-15.958-6.096-21.872 C407.711,233.281,387.978,232.195,386.205,232.135z M142.812,319.744c-0.084-0.1-0.124-0.194-0.166-0.3 c-0.896-2.157,0.179-7.389,1.761-11.222c6.792-7.594,14.945-14.565,24.353-20.841 C159.598,317.039,146.274,319.603,142.812,319.744z M200.984,122.695L200.984,122.695c-14.07-15.662-13.859-23.427-13.102-26.041 c1.242-4.369,6.848-6.02,6.896-6.035c2.824-0.768,4.538-0.617,6.064,1.058c3.451,3.791,6.415,15.232,5.244,36.218 C202.764,124.557,200.984,122.695,200.984,122.695z M193.714,256.068l0.243-0.928l-0.032,0.011 c7.045-27.593,17.205-67.996,23.047-93.949l0.211,0.201l0.021-0.124c18.9,17.798,47.88,43.831,82.579,70.907l-0.39,0.016 l0.574,0.433C267.279,235.396,228.237,241.84,193.714,256.068z M408.386,265.12c-2.489,9.146-7.277,10.396-11.665,10.396l0,0 c-5.094,0-9.998-2.12-11.116-2.632c-12.741-7.986-25.776-16.688-38.929-25.998c0.105,0,0.2,0,0.316,0 c22.549,0,37.568,1.369,38.158,1.411c3.766,0.14,15.684,1.9,20.82,7.938C407.984,258.602,408.755,261.431,408.386,265.12z\"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>"

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"__16RUpcS__Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 422.777 422.777\" style=\"enable-background:new 0 0 422.777 422.777;\" xml:space=\"preserve\"><g><g><path d=\"M416.628,82.068l-75.84-75.84c-8.226-8.198-21.534-8.198-29.76,0l-83.56,83.16l-20.96,20.96l-20.88,21.04l-104.8,104.8 l-20.96,20.96l-53.72,53.64c-8.198,8.226-8.198,21.534,0,29.76l76,76c8.226,8.198,21.534,8.198,29.76,0l304.72-304.72 C424.826,103.602,424.826,90.295,416.628,82.068z M409.668,104.868l-304.72,304.72c-4.351,4.125-11.169,4.125-15.52,0l-76-76 c-4.272-4.292-4.272-11.228,0-15.52l50.04-50.32l39.12,39.12c1.875,2.057,5.063,2.205,7.12,0.33 c2.057-1.875,2.205-5.063,0.33-7.12c-0.105-0.115-0.215-0.225-0.33-0.33l-39.12-39.12l13.84-13.84l17.76,17.76 c1.875,2.057,5.063,2.205,7.12,0.33c2.057-1.875,2.205-5.063,0.33-7.12c-0.105-0.115-0.215-0.225-0.33-0.33l-17.84-17.76 l13.84-13.84l17.76,17.76c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-17.76-17.76l13.84-13.84 l39.12,39.12c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-39.12-39.12l13.84-13.84l17.76,17.76 c1.875,2.057,5.063,2.205,7.12,0.33s2.205-5.063,0.33-7.12c-0.105-0.115-0.215-0.225-0.33-0.33l-17.76-17.76l13.84-13.84 l17.76,17.76c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-17.6-17.76l13.84-13.84l39.12,39.12 c2.192,1.716,5.359,1.33,7.075-0.862c1.442-1.842,1.427-4.433-0.035-6.258l-39.2-39.12l13.84-13.84l17.76,17.76 c1.875,2.057,5.063,2.205,7.12,0.33c2.057-1.875,2.205-5.063,0.33-7.12c-0.105-0.115-0.215-0.225-0.33-0.33l-17.76-17.76 l13.84-13.84l17.76,17.76c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-17.76-17.76l13.84-13.84 l39.12,39.12c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-39.12-39.12l13.84-13.84l17.76,17.76 c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-17.76-17.76l13.84-13.84l39.12,39.12 c2.057,1.875,5.245,1.727,7.12-0.33c1.753-1.924,1.753-4.866,0-6.79l-39.12-39.12l16.88-16.88c4.351-4.125,11.169-4.125,15.52,0 l76,76c4.272,4.292,4.272,11.228,0,15.52L409.668,104.868z\"></path></g></g><g><g><path d=\"M91.498,331.418c-0.01-0.01-0.02-0.02-0.03-0.03c-9.613-9.565-25.147-9.565-34.76,0c-9.615,9.599-9.628,25.175-0.03,34.79 c9.599,9.615,25.175,9.628,34.79,0.03C101.084,356.609,101.097,341.033,91.498,331.418z M84.428,358.988l-0.04,0.08 c-5.677,5.695-14.896,5.708-20.591,0.031c-5.695-5.677-5.708-14.896-0.031-20.591s14.896-5.708,20.591-0.031 c0.01,0.01,0.021,0.021,0.031,0.031C90.012,344.171,90.03,353.304,84.428,358.988z\"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>"

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"__2mLrIoK__Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 478.024 478.024\" style=\"enable-background:new 0 0 478.024 478.024;\" xml:space=\"preserve\"><g><g><path d=\"M411.703,73.561c-45.117-47.093-107.542-73.67-172.76-73.55C107.145-0.155,0.166,106.554,0,238.353 c-0.082,65.17,26.492,127.538,73.55,172.623c0.137,0.136,0.188,0.341,0.324,0.461c1.382,1.331,2.884,2.458,4.284,3.738 c3.84,3.413,7.68,6.946,11.725,10.24c2.167,1.707,4.42,3.413,6.639,4.983c3.823,2.85,7.646,5.7,11.639,8.329 c2.714,1.707,5.513,3.413,8.294,5.12c3.686,2.219,7.356,4.454,11.162,6.485c3.226,1.707,6.519,3.174,9.796,4.727 c3.584,1.707,7.117,3.413,10.786,4.949c3.669,1.536,7.356,2.731,11.076,4.062s6.929,2.56,10.496,3.652 c4.028,1.212,8.158,2.15,12.254,3.157c3.413,0.836,6.724,1.792,10.24,2.475c4.71,0.939,9.489,1.536,14.268,2.185 c2.953,0.41,5.837,0.99,8.823,1.28c7.817,0.768,15.701,1.195,23.654,1.195s15.838-0.427,23.654-1.195 c2.987-0.29,5.871-0.87,8.823-1.28c4.779-0.649,9.557-1.246,14.268-2.185c3.413-0.683,6.827-1.707,10.24-2.475 c4.096-1.007,8.226-1.946,12.254-3.157c3.567-1.092,7.014-2.423,10.496-3.652c3.482-1.229,7.441-2.56,11.076-4.062 s7.202-3.26,10.786-4.949c3.277-1.553,6.571-3.021,9.796-4.727c3.806-2.031,7.475-4.267,11.162-6.485 c2.782-1.707,5.581-3.26,8.294-5.12c3.994-2.628,7.817-5.478,11.639-8.329c2.219-1.707,4.471-3.243,6.639-4.983 c4.045-3.243,7.885-6.69,11.725-10.24c1.399-1.28,2.901-2.406,4.284-3.738c0.136-0.119,0.188-0.324,0.324-0.461 C499.644,319.798,502.881,168.732,411.703,73.561z M373.344,393.107c-3.106,2.731-6.315,5.325-9.557,7.834 c-1.911,1.468-3.823,2.918-5.786,4.318c-3.089,2.236-6.229,4.352-9.421,6.383c-2.321,1.485-4.693,2.918-7.083,4.318 c-3.004,1.707-6.059,3.413-9.148,5.12c-2.731,1.399-5.513,2.714-8.311,4.011s-5.888,2.679-8.909,3.891 c-3.021,1.212-6.229,2.355-9.387,3.413c-2.884,0.99-5.768,2.014-8.687,2.884c-3.413,1.024-6.98,1.86-10.513,2.714 c-2.765,0.648-5.495,1.382-8.294,1.929c-4.045,0.785-8.175,1.331-12.322,1.894c-2.355,0.307-4.693,0.734-7.066,0.973 c-6.554,0.631-13.193,1.007-19.9,1.007s-13.346-0.375-19.9-1.007c-2.372-0.239-4.71-0.666-7.066-0.973 c-4.147-0.563-8.277-1.109-12.322-1.894c-2.799-0.546-5.53-1.28-8.294-1.929c-3.533-0.853-7.049-1.707-10.513-2.714 c-2.918-0.87-5.803-1.894-8.687-2.884c-3.157-1.092-6.315-2.202-9.387-3.413c-3.072-1.212-5.973-2.543-8.909-3.891 s-5.581-2.611-8.311-4.011c-3.089-1.604-6.144-3.294-9.148-5.12c-2.389-1.399-4.762-2.833-7.083-4.318 c-3.191-2.031-6.332-4.147-9.421-6.383c-1.963-1.399-3.874-2.85-5.786-4.318c-3.243-2.509-6.451-5.12-9.557-7.834 c-0.751-0.563-1.434-1.28-2.167-1.929c0.763-58.057,38.06-109.321,93.065-127.915c27.503,13.083,59.435,13.083,86.938,0 c55.004,18.594,92.301,69.857,93.065,127.915C374.76,391.827,374.077,392.476,373.344,393.107z M179.43,136.849 c18.479-32.864,60.1-44.525,92.964-26.046s44.525,60.1,26.046,92.964c-6.131,10.904-15.141,19.914-26.046,26.046 c-0.085,0-0.188,0-0.29,0.102c-4.526,2.519-9.309,4.545-14.268,6.042c-0.887,0.256-1.707,0.597-2.645,0.819 c-1.707,0.444-3.499,0.751-5.257,1.058c-3.31,0.579-6.659,0.915-10.018,1.007h-1.946c-3.359-0.092-6.708-0.428-10.018-1.007 c-1.707-0.307-3.516-0.614-5.256-1.058c-0.905-0.222-1.707-0.563-2.645-0.819c-4.959-1.497-9.742-3.522-14.268-6.042l-0.307-0.102 C172.612,211.334,160.951,169.713,179.43,136.849z M405.753,357.336L405.753,357.336c-10.952-51.083-44.59-94.39-91.375-117.64 c38.245-41.661,35.475-106.438-6.186-144.683c-41.661-38.245-106.438-35.475-144.683,6.186 c-35.954,39.166-35.954,99.332,0,138.497c-46.785,23.251-80.423,66.557-91.375,117.64C6.69,265.153,28.366,137.371,120.549,71.927 s219.965-43.768,285.409,48.415c24.601,34.653,37.807,76.104,37.786,118.602C443.744,281.405,430.46,322.802,405.753,357.336z\"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>"

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32132a8e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-efdfbab2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7445036b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
  __webpack_require__(472)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bfc7ef4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74728dc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75bfa064",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40ee86a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c86faa5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56e742bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-052eff7d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(455)
  __webpack_require__(454)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-046784f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ef4d475",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c99529ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-563c36c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65b9ccb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.logosList), function(logo) {
    return _c('li', {
      key: logo.url
    }, [(logo.link) ? _c('a', {
      attrs: {
        "href": logo.link,
        "target": "_blank"
      }
    }, [(logo.imgUrl) ? _c('img', {
      attrs: {
        "src": logo.imgUrl,
        "width": logo.size.width,
        "height": logo.size.height
      }
    }) : _vm._e(), _vm._v(" "), (logo.text) ? _c('span', [_vm._v(_vm._s(logo.text))]) : _vm._e()]) : [(logo.imgUrl) ? _c('img', {
      attrs: {
        "src": logo.imgUrl,
        "width": logo.size.width,
        "height": logo.size.height
      }
    }) : _vm._e(), _vm._v(" "), (logo.text) ? _c('span', [_vm._v(_vm._s(logo.text))]) : _vm._e()]], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('mapPane'), _vm._v(" "), _c('search'), _vm._v(" "), _c('mobileToolsBar'), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    attrs: {
      "id": "left-container"
    }
  }, [_c('div', {
    staticClass: "layers"
  }, [_c('layerSelector'), _vm._v(" "), (_vm.showConsole) ? _c('editor-console') : _vm._e()], 1), _vm._v(" "), _c('annotations', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$parent.loaded),
      expression: "this.$parent.loaded"
    }]
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "mobile-layers"
  }, [_c('layerSelector'), _vm._v(" "), (_vm.layerSelectorActive && _vm.showConsole) ? _c('editor-console') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('annotations', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$parent.loaded),
      expression: "this.$parent.loaded"
    }]
  }) : _vm._e(), _vm._v(" "), _c('banner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$parent.loaded),
      expression: "this.$parent.loaded"
    }]
  }), _vm._v(" "), _c('contextInfoModal'), _vm._v(" "), _c('featureInfo'), _vm._v(" "), _c('feedback'), _vm._v(" "), _c('KMLOverlay'), _vm._v(" "), (_vm.llLogos) ? _c('Logos', {
    attrs: {
      "id": "ll_logos",
      "logosList": _vm.llLogos
    }
  }) : _vm._e(), _vm._v(" "), _c('measure'), _vm._v(" "), _c('file-drop', {
    attrs: {
      "show": _vm.showFileDropModal
    },
    on: {
      "disable": _vm.hideFileDropModal
    }
  }), _vm._v(" "), _c('login-modal', {
    attrs: {
      "show": _vm.showLoginModal
    },
    on: {
      "disable": _vm.hideLoginModal
    }
  }), _vm._v(" "), _c('v-dialog')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "annotations transparent-panel"
  }, [(_vm.annotationsActive) ? _c('div', {
    staticClass: "annotations-button-panel"
  }, [_c('div', {
    staticClass: "annotations-title"
  }, [_vm._v(_vm._s(_vm.$t("annotations.title")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "button actions",
    on: {
      "click": _vm.clearVector
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.open),
      expression: "!open"
    }],
    staticClass: "button actions",
    on: {
      "click": _vm.toggleLayer
    }
  }, [(_vm.visible) ? _c('icon', {
    attrs: {
      "name": "eye"
    }
  }) : _c('icon', {
    attrs: {
      "name": "eye-slash"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.togglePanel
    }
  }, [(_vm.open) ? _c('icon', {
    attrs: {
      "name": "angle-up"
    }
  }) : _c('icon', {
    attrs: {
      "name": "angle-down"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "annotations-panel"
  }, [_c('div', {
    staticClass: "geometry-types-selection"
  }, _vm._l((_vm.geometryTypes), function(geomType, idx) {
    return _c('div', {
      key: geomType,
      staticClass: "selector-button",
      class: {
        active: _vm.curGeomType === geomType, last: idx === _vm.geometryTypes.length - 1
      },
      on: {
        "click": function($event) {
          _vm.curGeomType = geomType
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(("annotations.geomTypes." + geomType))) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "feature-list"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ol-popup",
    attrs: {
      "id": "popup-annotations"
    }
  }, [_c('span', {
    staticClass: "ol-popup-closer",
    on: {
      "click": function($event) {
        return _vm.displayPopup(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "popup-content-annotations"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.featureText),
      expression: "featureText"
    }],
    attrs: {
      "placeholder": "Add label",
      "type": "text"
    },
    domProps: {
      "value": (_vm.featureText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.featureText = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "f-label",
    on: {
      "click": _vm.setFeatureStyle
    }
  }, [_vm._v("Add")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.$slots.header) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              Close\n            ")])])], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMobile) ? _c('div', {
    staticClass: "transparent-panel",
    attrs: {
      "id": "mobile-tools-bar"
    }
  }, [_c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": _vm.toggleLocation
    }
  }, [_c('icon', {
    class: {
      'icon-active': _vm.locationActive
    },
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" "), (_vm.gettingLocation) ? _c('div', {
    staticClass: "loader",
    attrs: {
      "id": "map-marker-loader"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('layerSelector')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('layerSelector'),
    attrs: {
      "name": "slms-layers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('measure')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('measure'),
    attrs: {
      "name": "slms-ruler"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('annotations')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('annotations'),
    attrs: {
      "name": "sticky-note"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('feedback')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('feedback'),
    attrs: {
      "name": "slms-feedback"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('kmlUpload')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('kmlUpload'),
    attrs: {
      "name": "slms-kml"
    }
  })], 1), _vm._v(" "), (_vm.enablePrint) ? _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": _vm.printMap
    }
  }, [_c('icon', {
    attrs: {
      "name": "slms-pdf"
    }
  }), _vm._v(" "), (_vm.printingInProgress) ? _c('div', {
    staticClass: "loader",
    attrs: {
      "id": "print-map-loader"
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.legendUrls), function(legendUrl, index) {
    return _c('div', {
      key: ("legendUrl-" + index)
    }, [_c('img', {
      attrs: {
        "src": legendUrl
      }
    })])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.kmlOverlay) ? _c('div', {
    attrs: {
      "id": "outer"
    }
  }, [_c('div', {
    attrs: {
      "id": "message"
    }
  }, [_c('button', {
    staticClass: "small",
    attrs: {
      "id": "clearButton"
    },
    on: {
      "click": _vm.clearFeedback
    }
  }, [_vm._v(_vm._s(_vm.$t("kmlOverlay.clear")))])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 632:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.layerSelectorActive) ? _c('ul', {
    attrs: {
      "id": "layer-selector"
    }
  }, [_c('item', {
    staticClass: "item",
    attrs: {
      "conf": _vm.groups
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        return _vm.clickHandler(_vm.result)
      }
    }
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.result.title))]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(_vm.result.fromtable) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('modal', [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.error ? 'Error' : 'Login'))]), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.error) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.error))])]) : _c('table', [_c('tr', [_c('td', [_vm._v("User:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter your username"
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pasword:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.error) ? _c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("\n      Ok\n    ")]) : [_c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n        Login\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "modal-default-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        Cancel\n      ")])]], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-content"
  }, _vm._l((_vm.times), function(time) {
    return _c('li', {
      key: time.id
    }, [_c('span', {
      class: {
        selected: time === _vm.selectedTime
      },
      on: {
        "click": function($event) {
          return _vm.set(time)
        }
      }
    }, [_vm._v(_vm._s(time.humanReadable))]), _vm._v(" "), _c('br')])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "context-info-modal",
      "draggable": true,
      "resizable": true,
      "minWidth": 250,
      "minHeight": 220
    },
    on: {
      "closed": _vm.resetState
    }
  }, [_c('div', {
    staticClass: "context-info-modal"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.closeByName
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.showDownloadLinks) ? _c('div', {
    staticClass: "context-info-modal-download-links"
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.layerInfo.label))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.requestEmailChange
    }
  }, [_vm._v(_vm._s(_vm.$t('contextInfoModal.changeEmailLabel')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tbody', _vm._l((_vm.downloadLinksIntl), function(downLink) {
    return _c('tr', {
      key: downLink.url
    }, [_c('td', [_c('a', {
      attrs: {
        "href": downLink.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      on: {
        "click": function($event) {
          return _vm.processDownloadLink(downLink)
        }
      }
    }, [_vm._v(_vm._s(downLink.label))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.showEmailPrompt) ? _c('div', {
    staticClass: "context-info-modal-email-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("contextInfoModal.emailTitle")))]), _vm._v(" "), _c('input', {
    class: {
      invalid: _vm.emailInvalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "change": _vm.changeEmail
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.validateEmailAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t("contextInfoModal.submitDataLabel")))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enableFeedback) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.categories.length) ? _c('div', {
    attrs: {
      "id": "feedback-category"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("feedback.selectCategory")))]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return _c('option', {
      key: cat.id
    }, [_vm._v(_vm._s(cat))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tools"
    }
  }, [_vm._v("\n    Draw:\n    "), (_vm.drawOptions.includes('Point')) ? _c('button', {
    staticClass: "small",
    class: {
      active: _vm.draw === 'Point'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDrawTool('Point')
      }
    }
  }, [_vm._v("Points")]) : _vm._e(), _vm._v(" "), (_vm.drawOptions.includes('Polygon')) ? _c('button', {
    staticClass: "small",
    class: {
      active: _vm.draw === 'Polygon'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDrawTool('Polygon')
      }
    }
  }, [_vm._v("Polygons")]) : _vm._e()]), _vm._v(" "), (_vm.senderEmailIsRequired) ? _c('div', {
    attrs: {
      "id": "sender"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senderEmail),
      expression: "senderEmail"
    }],
    attrs: {
      "id": "message-sender",
      "type": "email",
      "name": "email",
      "placeholder": "Write your email"
    },
    domProps: {
      "value": (_vm.senderEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senderEmail = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "message"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "id": "message-text",
      "rows": "6",
      "placeholder": "Write your message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "buttons"
    }
  }, [_c('button', {
    staticClass: "small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.disableFeedback
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    attrs: {
      "type": "button",
      "disabled": _vm.drew === false
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('button', {
    staticClass: "small danger",
    attrs: {
      "type": "button",
      "disabled": _vm.disableSend
    },
    on: {
      "click": _vm.sendFeedback
    }
  }, [_vm._v("Send")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.conf.isGroup) ? _c('div', {
    staticClass: "group",
    class: {
      dimmed: !_vm.nContexts
    },
    on: {
      "click": _vm.toggleContent
    }
  }, [_c('span', {
    staticClass: "line icon"
  }, [_c('icon', {
    staticClass: "open-button",
    attrs: {
      "name": _vm.open ? 'minus-square-o' : 'plus-square-o'
    }
  }), _vm._v(" "), _c('span', {
    class: {
      handle: _vm.editing
    }
  }, [_vm._v(_vm._s(_vm.isRoot ? _vm.$t("layerSelector.layers") : _vm.label))])], 1), _vm._v(" "), (_vm.conf.infoFile) ? _c('span', {
    staticClass: "info-link icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showInfo($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-circle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.nActive ? '‎[' + _vm.locNActive + '‎]' : null))]), _vm._v(" "), (_vm.editing && !_vm.isRoot) ? [_c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "pencil-square-o"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "trash-o"
    }
  })], 1)] : _vm._e()], 2) : _c('div', [(_vm.hasLayers) ? _c('span', {
    staticClass: "icon",
    on: {
      "click": _vm.toggleContent
    }
  }, [(_vm.open) ? _c('icon', {
    staticClass: "open-button",
    attrs: {
      "name": "caret-down"
    }
  }) : _c('icon', {
    staticClass: "open-button",
    attrs: {
      "name": "caret-right"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasLayers) ? _c('span', {
    staticClass: "icon",
    on: {
      "click": _vm.toggleActive
    }
  }, [(_vm.conf.parent.exclusive) ? [(_vm.active) ? _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "dot-circle-o"
    }
  }) : _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "circle"
    }
  })] : [(_vm.active) ? _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "check-square"
    }
  }) : _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "square"
    }
  })]], 2) : _vm._e(), _vm._v(" "), (_vm.conf.hasLegends) ? _c('span', {
    staticClass: "icon",
    staticStyle: {
      "padding-left": "2px",
      "padding-right": "2px"
    },
    on: {
      "click": _vm.toggleLegend
    }
  }, [_c('icon', {
    staticClass: "legend-link",
    class: {
      active: _vm.active
    },
    attrs: {
      "name": "th-list"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.conf.inlineLegendUrl) ? _c('img', {
    staticClass: "inline-legend",
    attrs: {
      "src": _vm.conf.inlineLegendUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      dimmed: !_vm.hasLayers, handle: _vm.editing
    },
    on: {
      "mouseover": function($event) {
        return _vm.highlightContext(true)
      },
      "mouseout": function($event) {
        return _vm.highlightContext(false)
      },
      "click": _vm.toggleActive
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.conf.infoFile) ? _c('span', {
    staticClass: "info-link icon",
    on: {
      "click": _vm.showInfo
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-circle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.conf.times && !!this.conf.times.length) ? _c('span', {
    staticClass: "times-button icon",
    class: {
      active: _vm.showTimeMenu
    },
    on: {
      "click": _vm.toggleTimeMenu
    }
  }, [_c('icon', {
    attrs: {
      "name": "clock-o"
    }
  }), _vm._v(" " + _vm._s(_vm.selectedTime.humanReadable) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.hasStatistics) ? _c('span', {
    staticClass: "icon statistics",
    attrs: {
      "title": _vm.$t('item.statisticsAvailable')
    }
  }, [_c('icon', {
    attrs: {
      "name": "bar-chart"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasDataDownload) ? _c('span', {
    staticClass: "icon datadownload info-link",
    attrs: {
      "title": _vm.$t('item.downloadAvailable')
    },
    on: {
      "click": _vm.showDownloads
    }
  }, [_c('icon', {
    attrs: {
      "name": "download"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showTimeMenu) ? _c('time-select', {
    attrs: {
      "times": _vm.conf.times,
      "selectedTime": _vm.selectedTime
    },
    on: {
      "setTime": _vm.setTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? [_c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "pencil-square-o"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "trash-o"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticStyle: {
      "padding-left": "21px"
    }
  }, [_c('icon', {
    attrs: {
      "name": "adjust"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opacity),
      expression: "opacity"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.opacity)
    },
    on: {
      "input": _vm.updateOpacity,
      "__r": function($event) {
        _vm.opacity = $event.target.value
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.conf.hasLegends && _vm.active && _vm.showLegend) ? [_c('context-legend', {
    attrs: {
      "conf": _vm.conf
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.editing) ? [(_vm.conf.isGroup) ? _c('draggable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticStyle: {
      "min-height": "10px"
    },
    attrs: {
      "element": "ul",
      "options": {
        group: 'items',
        draggable: '.item',
        animation: 150,
        handle: '.handle'
      }
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.list), function(conf) {
    return _c('item', {
      key: conf.id,
      staticClass: "item unselectable",
      attrs: {
        "conf": conf
      }
    })
  }), 1) : _vm._e()] : [(_vm.conf.isGroup) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticStyle: {
      "min-height": "10px"
    }
  }, _vm._l((_vm.list), function(conf) {
    return _c('item', {
      key: conf.id,
      staticClass: "item unselectable",
      attrs: {
        "conf": conf
      }
    })
  }), 1) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.hideUploadPopup()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    attrs: {
      "id": "dropTarget"
    }
  }, [_c('span', {
    attrs: {
      "id": "dropText"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('fileDrop.dropKml'))
    }
  })])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('modal', {
    attrs: {
      "name": "stats-modal",
      "draggable": true,
      "resizable": true,
      "minWidth": 250,
      "minHeight": 220
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h1', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.$t("featureInfo.info")))]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.statisticsUrl
    }
  })])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "props-modal",
      "draggable": true,
      "resizable": true,
      "minWidth": 250,
      "minHeight": 220
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h1', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.$t("featureInfo.attributes")))]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', _vm._l((_vm.popupAttributes), function(attr) {
    return _c('tr', {
      key: attr.id
    }, [_c('th', [_vm._v(_vm._s(attr.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(attr.value))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "ol-popup",
    attrs: {
      "id": "popup"
    }
  }, [_c('a', {
    staticClass: "ol-popup-closer",
    attrs: {
      "href": "#",
      "id": "popup-closer"
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "popup-content"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("featureInfo.moreData")))]), _vm._v(" "), _vm._l((_vm.statisticsConfs), function(stat, i) {
    return _c('li', {
      key: i,
      staticClass: "statsLink",
      on: {
        "click": function($event) {
          return _vm.showStatistics(stat, _vm.statisticsFeatures[i])
        }
      }
    }, [_vm._v(_vm._s(_vm.statisticsLabels[i]))])
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((!_vm.isMobile || !_vm.measure) && _vm.wfsSearchConfig && _vm.wfsSearchConfig.layersToQuery) ? _c('div', {
    attrs: {
      "id": "search"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.noop($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": _vm.goSearching,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), (_vm.results.length) ? _c('div', {
    staticClass: "columns",
    attrs: {
      "id": "search-results"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        (_vm.results = [])
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, _vm._l((_vm.results), function(result) {
    return _c('search-results', _vm._b({
      key: result.id
    }, 'search-results', {
      result: result,
      clickHandler: _vm.clickHandler
    }, false))
  }), 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      danger: _vm.user.authenticated
    },
    attrs: {
      "id": "header"
    }
  }, [_c('img', {
    attrs: {
      "id": "header-img",
      "src": "/static/configuration/logos.png"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "title"
    }
  }, [(!_vm.isMobile) ? _c('h1', {
    class: {
      hasSubtitle: _vm.$te('banner.subtitle')
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.title")))]) : _vm._e(), _vm._v(" "), (!_vm.isMobile && _vm.$te('banner.subtitle')) ? _c('h2', [_vm._v(_vm._s(_vm.$t("banner.subtitle")))]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "title-div",
    class: {
      hasSubtitle: _vm.$te('banner.subtitle')
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.title")))]) : _vm._e(), _vm._v(" "), (_vm.isMobile && _vm.$te('banner.subtitle')) ? _c('div', {
    staticClass: "subtitle-div"
  }, [_vm._v(_vm._s(_vm.$t("banner.subtitle")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "user-button"
    }
  }, [_c('div', {
    attrs: {
      "id": "user-icon-container"
    },
    on: {
      "click": _vm.toggleUserPanel
    }
  }, [(_vm.isMobile) ? _c('icon', {
    staticClass: "user-icon",
    class: {
      'icon-active': _vm.showUserPanel
    },
    attrs: {
      "name": "slms-user"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showUserPanel) ? _c('div', {
    staticClass: "transparent-panel user-panel"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("banner.languages")) + ":")]), _vm._v(" "), _vm._l((_vm.languages), function(language) {
    return _c('div', {
      key: language.id,
      on: {
        "click": function($event) {
          return _vm.setLanguage(language.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": language.id === _vm.selectedLanguage ? 'dot-circle-o' : 'circle'
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(language.label))])], 1)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "admin-button"
    },
    on: {
      "click": _vm.adminButtonClick
    }
  }, [_c('icon', {
    attrs: {
      "name": !_vm.user.authenticated ? 'slms-login' : 'slms-logout'
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(!_vm.user.authenticated ? 'Admin' : 'Logout'))])], 1)], 2) : _vm._e()]), _vm._v(" "), (!_vm.isMobile && _vm.languages.length > 1) ? _c('ul', {
    staticClass: "buttons",
    attrs: {
      "id": "languageLinks"
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('li', {
      key: language.id
    }, [(language.id === _vm.selectedLanguage) ? _c('span', {
      attrs: {
        "href": '?lang=' + language.id
      }
    }, [_vm._v(_vm._s(language.label))]) : _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.setLanguage(language.id)
        }
      }
    }, [_vm._v(_vm._s(language.label))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('ul', {
    staticClass: "buttons",
    attrs: {
      "id": "tools"
    }
  }, [(!_vm.user.authenticated) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.showLoginDialog(true)
      }
    }
  }, [_vm._v("Admin")])]) : _c('li', [_c('a', {
    attrs: {
      "id": "logout-button",
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enableFeedback($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.feedback")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.enableUpload($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.uploadKml")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleMeasure($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.measure")))])]), _vm._v(" "), (_vm.enablePrint) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.printMap($event)
      }
    }
  }, [_vm._v("PDF")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "measureOptions"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toolTypeSelected),
      expression: "toolTypeSelected"
    }],
    staticClass: "hidden",
    attrs: {
      "id": "measureToolType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.toolTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "length"
    }
  }, [_vm._v("Length (LineString)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "area"
    }
  }, [_vm._v("Area (Polygon)")])])])
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports = {"layout":"A4 portrait","srs":"EPSG:3857","units":"meters","geodetic":true,"outputFilename":"map","outputFormat":"pdf","layers":[{"type":"WMS","layers":["unredd:provinces"],"baseURL":"http://147.135.130.114/geoserver/wms?","format":"image/png"}],"pages":[{"mapTitle":"This is the title","center":[-8237642.319,4968191.93],"scale":25000,"dpi":150,"geodetic":false,"strictEpsg4326":false}],"legends":[{"classes":[{"icons":["http://www.rdc-snsf.org/portal/static/loc/en/images/ucl_2010.png"],"name":""}],"name":"a class name"}]}

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(321);
module.exports = __webpack_require__(322);


/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = (function (method, url) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);

    headers.forEach(function (header) {
      xhr.setRequestHeader.apply(xhr, header);
    });

    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status >= 200 && this.status < 300) {
          resolve(this.responseText);
        } else {
          reject({
            status: this.status,
            statusText: this.responseText || "Error getting data from " + url
          });
        }
      }
    };

    xhr.send(data);
  });
});

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__httpRequest__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);







/* harmony default export */ __webpack_exports__["a"] = ({
  user: { authenticated: false },

  login: function login(creds, redirect) {
    var _this = this;

    var loginUrl = __WEBPACK_IMPORTED_MODULE_3_config__["layersConfigApi"].baseUrl + __WEBPACK_IMPORTED_MODULE_3_config__["layersConfigApi"].loginUrl;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__httpRequest__["a" /* default */])('POST', loginUrl, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(creds), [['Content-Type', 'application/json']]).then(function (res) {
      var data = JSON.parse(res);
      localStorage.setItem('id_token', data.id_token);
      _this.user.authenticated = true;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(_this.user);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    });
  },
  logout: function logout() {
    localStorage.removeItem('id_token');
    this.user.authenticated = false;
  },
  checkAuth: function checkAuth() {
    var jwt = localStorage.getItem('id_token');
    this.user.authenticated = !!jwt;
  },
  getAuthHeader: function getAuthHeader() {
    return { 'Authorization': 'Bearer ' + localStorage.getItem('id_token') };
  },
  getAuthToken: function getAuthToken() {
    return 'Bearer ' + localStorage.getItem('id_token');
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[648]);


// WEBPACK FOOTER //
// static/js/app.fdeb1d2769def2d2dbcd.js